const database = [
    {
        "id": 11321,
        "date": "2023-09-11T19:07:07",
        "date_gmt": "2023-09-11T19:07:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11321"
        },
        "modified": "2023-10-31T20:49:48",
        "modified_gmt": "2023-10-31T20:49:48",
        "slug": "permanent-family-physician-physician-lead-ubc-student-health-services",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-physician-lead-ubc-student-health-services/",
        "title": {
            "rendered": "Permanent Family Physician, Physician Lead &#8211; UBC Student Health Services"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            215
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8996,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "The salary for this position will be a minimum of 225,882 to a max of $282,352 (for a full-time role). ",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2457018",
            "job_listing-clinic_lattitude": 49.2643047,
            "job_listing-job_location": "49.2643047%-123.2457018",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11321"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11321"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11321"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11321"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11321"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11321"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11321"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11320,
        "date": "2023-09-11T18:58:44",
        "date_gmt": "2023-09-11T18:58:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11320"
        },
        "modified": "2023-10-31T20:49:33",
        "modified_gmt": "2023-10-31T20:49:33",
        "slug": "permanent-family-physician-medical-office-on-commercial-and-e-11th",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-commercial-and-e-11th/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Medical Office on Commercial and E 11th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            216
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8791,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0695196",
            "job_listing-clinic_lattitude": 49.2607267,
            "job_listing-job_location": "49.2607267%-123.0695196",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11320"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8791"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11320"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11320"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11320"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11320"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11320"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11320"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11319,
        "date": "2023-09-11T18:55:08",
        "date_gmt": "2023-09-11T18:55:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11319"
        },
        "modified": "2023-09-11T18:55:08",
        "modified_gmt": "2023-09-11T18:55:08",
        "slug": "locum-family-physician-simply-wellness",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-simply-wellness/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Simply Wellness"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8964,
            "set_specific_time": true,
            "job_listing-start_date": "20231001",
            "job_listing-end_date": "20231012",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Office hours ~830am-5pm, Avg number of pts ~30-40/day, flexible 4-6 pts/hour, virtual and in person",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0674904",
            "job_listing-clinic_lattitude": 49.2460432,
            "job_listing-job_location": "49.2460432%-123.0674904",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11319"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11319"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11319"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11319"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11319"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11319"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11319"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11205,
        "date": "2023-08-30T19:40:13",
        "date_gmt": "2023-08-30T19:40:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11205"
        },
        "modified": "2023-08-30T19:40:13",
        "modified_gmt": "2023-08-30T19:40:13",
        "slug": "permanent-part-time-fp-for-long-term-care-panel-at-lakeview-care-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-part-time-fp-for-long-term-care-panel-at-lakeview-care-centre/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Lakeview Care Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9142,
            "set_specific_time": false,
            "job_listing-start_date": "20230729",
            "job_listing-end_date": "20240101",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>\r\n&nbsp;",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0665503",
            "job_listing-clinic_lattitude": 49.2535766,
            "job_listing-job_location": "49.2535766%-123.0665503",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11205"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9142"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11205"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11205"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11205"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11205"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11205"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11205"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11201,
        "date": "2023-08-30T00:47:06",
        "date_gmt": "2023-08-30T00:47:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11201"
        },
        "modified": "2023-08-30T18:46:07",
        "modified_gmt": "2023-08-30T18:46:07",
        "slug": "nurse-practitioner-pacific-medical-clinic-fraser-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-pacific-medical-clinic-fraser-st/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Pacific Medical Clinic (Fraser St.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9305,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0902688",
            "job_listing-clinic_lattitude": 49.2285535,
            "job_listing-job_location": "49.2285535%-123.0902688",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11201"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9305"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11201"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11201"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11201"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11201"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11201"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11201"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11200,
        "date": "2023-08-30T00:46:05",
        "date_gmt": "2023-08-30T00:46:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11200"
        },
        "modified": "2023-08-30T18:44:23",
        "modified_gmt": "2023-08-30T18:44:23",
        "slug": "nurse-practitioner-iss-of-bc-welcome-centre-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-iss-of-bc-welcome-centre-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; ISS of BC Welcome Centre Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8868,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0653303",
            "job_listing-clinic_lattitude": 49.2610006,
            "job_listing-job_location": "49.2610006%-123.0653303",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11200"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8868"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11200"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11200"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11200"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11200"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11200"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11200"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11198,
        "date": "2023-08-30T00:44:46",
        "date_gmt": "2023-08-30T00:44:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11198"
        },
        "modified": "2023-08-30T18:44:04",
        "modified_gmt": "2023-08-30T18:44:04",
        "slug": "nurse-practitioner-care-point-medical-clinic-joyce-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-care-point-medical-clinic-joyce-st/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Care Point Medical Clinic (Joyce St.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8758,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0319535",
            "job_listing-clinic_lattitude": 49.2378195,
            "job_listing-job_location": "49.2378195%-123.0319535",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11198"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11198"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11198"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11198"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11198"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11198"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11198"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11197,
        "date": "2023-08-30T00:43:32",
        "date_gmt": "2023-08-30T00:43:32",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11197"
        },
        "modified": "2023-08-30T18:43:41",
        "modified_gmt": "2023-08-30T18:43:41",
        "slug": "nurse-practitioner-blue-water-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-blue-water-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Blue Water Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8749,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0380326",
            "job_listing-clinic_lattitude": 49.2352974,
            "job_listing-job_location": "49.2352974%-123.0380326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11197"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8749"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11197"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11197"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11197"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11197"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11197"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11197"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11196,
        "date": "2023-08-30T00:42:28",
        "date_gmt": "2023-08-30T00:42:28",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11196"
        },
        "modified": "2023-08-30T18:43:18",
        "modified_gmt": "2023-08-30T18:43:18",
        "slug": "nurse-practitioner-well-health-hasting-sunrise-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-hasting-sunrise-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; WELL Health Hasting Sunrise Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9015,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.058289",
            "job_listing-clinic_lattitude": 49.2809177,
            "job_listing-job_location": "49.2809177%-123.058289",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11196"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9015"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11196"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11196"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11196"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11196"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11196"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11196"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11195,
        "date": "2023-08-30T00:41:30",
        "date_gmt": "2023-08-30T00:41:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11195"
        },
        "modified": "2023-08-30T18:42:55",
        "modified_gmt": "2023-08-30T18:42:55",
        "slug": "nurse-practitioner-urban-native-youth-association",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-urban-native-youth-association/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Urban Native Youth Association"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9003,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0715372",
            "job_listing-clinic_lattitude": 49.2810865,
            "job_listing-job_location": "49.2810865%-123.0715372",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11195"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9003"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11195"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11195"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11195"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11195"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11195"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11195"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11194,
        "date": "2023-08-30T00:40:22",
        "date_gmt": "2023-08-30T00:40:22",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11194"
        },
        "modified": "2023-08-30T18:42:21",
        "modified_gmt": "2023-08-30T18:42:21",
        "slug": "nurse-practitioner-kilala-lelum",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-kilala-lelum/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Kilala Lelum"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8886,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.090832",
            "job_listing-clinic_lattitude": 49.2829122,
            "job_listing-job_location": "49.2829122%-123.090832",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11194"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8886"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11194"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11194"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11194"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11194"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11194"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11194"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11192,
        "date": "2023-08-30T00:38:05",
        "date_gmt": "2023-08-30T00:38:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11192"
        },
        "modified": "2023-08-30T18:41:23",
        "modified_gmt": "2023-08-30T18:41:23",
        "slug": "nurse-practitioner-doc-side-medical",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-doc-side-medical/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Doc-Side Medical"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8822,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0901345",
            "job_listing-clinic_lattitude": 49.2809015,
            "job_listing-job_location": "49.2809015%-123.0901345",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11192"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8822"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11192"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11192"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11192"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11192"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11192"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11192"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11191,
        "date": "2023-08-30T00:36:34",
        "date_gmt": "2023-08-30T00:36:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11191"
        },
        "modified": "2023-08-30T18:41:04",
        "modified_gmt": "2023-08-30T18:41:04",
        "slug": "nurse-practitioner-care-point-medical-clinic-commercial-dr",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-care-point-medical-clinic-commercial-dr/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Care Point Medical Clinic (Commercial Dr)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8754,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.069817",
            "job_listing-clinic_lattitude": 49.2701651,
            "job_listing-job_location": "49.2701651%-123.069817",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11191"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8754"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11191"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11191"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11191"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11191"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11191"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11191"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11190,
        "date": "2023-08-30T00:34:44",
        "date_gmt": "2023-08-30T00:34:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11190"
        },
        "modified": "2023-08-30T18:40:22",
        "modified_gmt": "2023-08-30T18:40:22",
        "slug": "nurse-practitioner-yaletown-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-yaletown-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Yaletown Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9030,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1228869",
            "job_listing-clinic_lattitude": 49.2732651,
            "job_listing-job_location": "49.2732651%-123.1228869",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11190"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9030"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11190"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11190"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11190"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11190"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11190"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11190"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11189,
        "date": "2023-08-30T00:33:08",
        "date_gmt": "2023-08-30T00:33:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11189"
        },
        "modified": "2023-08-30T18:39:55",
        "modified_gmt": "2023-08-30T18:39:55",
        "slug": "nurse-practitioner-well-health-city-view-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-city-view-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; WELL Health City View Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9010,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1196326",
            "job_listing-clinic_lattitude": 49.2635805,
            "job_listing-job_location": "49.2635805%-123.1196326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11189"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9010"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11189"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11189"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11189"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11189"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11189"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11189"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11188,
        "date": "2023-08-30T00:31:59",
        "date_gmt": "2023-08-30T00:31:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11188"
        },
        "modified": "2023-08-30T18:26:26",
        "modified_gmt": "2023-08-30T18:26:26",
        "slug": "nurse-practitioner-vancouver-family-practice-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-vancouver-family-practice-centre/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Vancouver Family Practice Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9005,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1165465",
            "job_listing-clinic_lattitude": 49.2609085,
            "job_listing-job_location": "49.2609085%-123.1165465",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11188"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9005"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11188"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11188"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11188"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11188"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11188"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11188"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11187,
        "date": "2023-08-30T00:28:58",
        "date_gmt": "2023-08-30T00:28:58",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11187"
        },
        "modified": "2023-08-30T18:26:03",
        "modified_gmt": "2023-08-30T18:26:03",
        "slug": "nurse-practitioner-seymour-health-centre-hornby",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-seymour-health-centre-hornby/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Seymour Health Centre (Hornby)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": "",
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11187"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11187"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11187"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11187"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11187"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11187"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11187"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11185,
        "date": "2023-08-30T00:26:38",
        "date_gmt": "2023-08-30T00:26:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11185"
        },
        "modified": "2023-08-30T18:25:42",
        "modified_gmt": "2023-08-30T18:25:42",
        "slug": "nurse-practitioner-seymour-health-centre-granville",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-seymour-health-centre-granville/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Seymour Health Centre (Granville)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8963,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1395812",
            "job_listing-clinic_lattitude": 49.2652565,
            "job_listing-job_location": "49.2652565%-123.1395812",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11185"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8963"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11185"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11185"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11185"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11185"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11185"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11185"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11184,
        "date": "2023-08-30T00:25:48",
        "date_gmt": "2023-08-30T00:25:48",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11184"
        },
        "modified": "2023-08-30T18:25:16",
        "modified_gmt": "2023-08-30T18:25:16",
        "slug": "nurse-practitioner-granville-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-granville-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Granville Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8843,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1383608",
            "job_listing-clinic_lattitude": 49.2629811,
            "job_listing-job_location": "49.2629811%-123.1383608",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11184"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8843"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11184"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11184"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11184"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11184"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11184"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11184"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11183,
        "date": "2023-08-30T00:24:13",
        "date_gmt": "2023-08-30T00:24:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11183"
        },
        "modified": "2023-08-30T18:24:19",
        "modified_gmt": "2023-08-30T18:24:19",
        "slug": "nurse-practitioner-genetica-medical-and-wellness-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-genetica-medical-and-wellness-centre/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Genetica Medical and Wellness Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8839,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1280715",
            "job_listing-clinic_lattitude": 49.2793325,
            "job_listing-job_location": "49.2793325%-123.1280715",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11183"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8839"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11183"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11183"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11183"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11183"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11183"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11183"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11182,
        "date": "2023-08-30T00:18:16",
        "date_gmt": "2023-08-30T00:18:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11182"
        },
        "modified": "2023-08-30T18:23:45",
        "modified_gmt": "2023-08-30T18:23:45",
        "slug": "nurse-practitioner-denman-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-denman-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Denman Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8820,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1410324",
            "job_listing-clinic_lattitude": 49.287948,
            "job_listing-job_location": "49.287948%-123.1410324",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11182"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8820"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11182"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11182"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11182"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11182"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11182"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11182"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11181,
        "date": "2023-08-30T00:17:14",
        "date_gmt": "2023-08-30T00:17:14",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11181"
        },
        "modified": "2023-08-30T18:15:12",
        "modified_gmt": "2023-08-30T18:15:12",
        "slug": "nurse-practitioner-coal-harbour-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-coal-harbour-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Coal Harbour Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8798,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1243287",
            "job_listing-clinic_lattitude": 49.2876168,
            "job_listing-job_location": "49.2876168%-123.1243287",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11181"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8798"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11181"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11181"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11181"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11181"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11181"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11181"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11180,
        "date": "2023-08-30T00:15:53",
        "date_gmt": "2023-08-30T00:15:53",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11180"
        },
        "modified": "2023-08-30T18:13:51",
        "modified_gmt": "2023-08-30T18:13:51",
        "slug": "nurse-practitioner-caya-health",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-caya-health/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; CAYA Health"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141,
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9729,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1161003",
            "job_listing-clinic_lattitude": 49.2608996,
            "job_listing-job_location": "49.2608996%-123.1161003",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11180"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9729"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11180"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11180"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11180"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11180"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11180"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11180"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11179,
        "date": "2023-08-30T00:13:25",
        "date_gmt": "2023-08-30T00:13:25",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11179"
        },
        "modified": "2023-08-30T18:11:57",
        "modified_gmt": "2023-08-30T18:11:57",
        "slug": "nurse-practitioner-care-point-medical-clinic-davie-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-care-point-medical-clinic-davie-st/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Care Point Medical Clinic (Davie St)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8756,
            "set_specific_time": false,
            "job_listing-start_date": "20230829",
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1313165",
            "job_listing-clinic_lattitude": 49.2807463,
            "job_listing-job_location": "49.2807463%-123.1313165",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11179"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11179"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11179"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11179"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11179"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11179"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11179"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11172,
        "date": "2023-08-29T19:59:57",
        "date_gmt": "2023-08-29T19:59:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11172"
        },
        "modified": "2023-08-30T15:57:49",
        "modified_gmt": "2023-08-30T15:57:49",
        "slug": "nurse-practitioner-south-hill-family-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-south-hill-family-health-centre/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; South Hill Family Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8975,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0802276",
            "job_listing-clinic_lattitude": 49.2525625,
            "job_listing-job_location": "49.2525625%-123.0802276",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11172"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8975"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11172"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11172"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11172"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11172"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11172"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11172"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11171,
        "date": "2023-08-29T17:21:03",
        "date_gmt": "2023-08-29T17:21:03",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11171"
        },
        "modified": "2023-08-29T17:21:03",
        "modified_gmt": "2023-08-29T17:21:03",
        "slug": "nurse-practitioner-vycare-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-vycare-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; VyCare Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9007,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.026608",
            "job_listing-clinic_lattitude": 49.2323817,
            "job_listing-job_location": "49.2323817%-123.026608",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11171"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9007"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11171"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11171"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11171"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11171"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11171"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11171"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11170,
        "date": "2023-08-29T17:19:06",
        "date_gmt": "2023-08-29T17:19:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11170"
        },
        "modified": "2023-08-29T17:19:06",
        "modified_gmt": "2023-08-29T17:19:06",
        "slug": "nurse-practitioner-mint-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-mint-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Mint Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10901,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0597165",
            "job_listing-clinic_lattitude": 49.2428127,
            "job_listing-job_location": "49.2428127%-123.0597165",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11170"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10901"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11170"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11170"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11170"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11170"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11170"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11170"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11169,
        "date": "2023-08-29T16:38:33",
        "date_gmt": "2023-08-29T16:38:33",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11169"
        },
        "modified": "2023-08-29T16:38:33",
        "modified_gmt": "2023-08-29T16:38:33",
        "slug": "nurse-practitioner-tlc-medical-clinic-granville",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-tlc-medical-clinic-granville/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; TLC Medical Clinic (Granville)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8993,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1409633",
            "job_listing-clinic_lattitude": 49.2195936,
            "job_listing-job_location": "49.2195936%-123.1409633",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11169"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8993"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11169"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11169"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11169"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11169"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11169"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11169"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11168,
        "date": "2023-08-29T16:32:56",
        "date_gmt": "2023-08-29T16:32:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11168"
        },
        "modified": "2023-08-29T16:32:56",
        "modified_gmt": "2023-08-29T16:32:56",
        "slug": "nurse-practitioner-well-health-medical-clinic-kerrisdale",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-medical-clinic-kerrisdale/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; WELL Health Medical Clinic (Kerrisdale)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9016,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1534977",
            "job_listing-clinic_lattitude": 49.2337865,
            "job_listing-job_location": "49.2337865%-123.1534977",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11168"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9016"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11168"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11168"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11168"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11168"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11168"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11168"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11167,
        "date": "2023-08-29T16:31:04",
        "date_gmt": "2023-08-29T16:31:04",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11167"
        },
        "modified": "2023-08-29T16:33:28",
        "modified_gmt": "2023-08-29T16:33:28",
        "slug": "nurse-practitioner-well-health-medical-clinic-point-grey",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-medical-clinic-point-grey/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; WELL Health Medical Clinic (Point Grey)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9018,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2075374",
            "job_listing-clinic_lattitude": 49.2636084,
            "job_listing-job_location": "49.2636084%-123.2075374",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11167"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9018"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11167"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11167"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11167"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11167"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11167"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11167"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11156,
        "date": "2023-08-25T19:26:28",
        "date_gmt": "2023-08-25T19:26:28",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11156"
        },
        "modified": "2023-08-25T19:26:28",
        "modified_gmt": "2023-08-25T19:26:28",
        "slug": "nurse-practitioner-mid-main-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-mid-main-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Mid-Main Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8932,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1012107",
            "job_listing-clinic_lattitude": 49.265259,
            "job_listing-job_location": "49.265259%-123.1012107",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11156"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8932"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11156"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11156"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11156"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11156"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11156"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11156"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11153,
        "date": "2023-08-25T19:24:42",
        "date_gmt": "2023-08-25T19:24:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11153"
        },
        "modified": "2023-08-25T19:24:42",
        "modified_gmt": "2023-08-25T19:24:42",
        "slug": "nurse-practitioner-pacific-medical-clinic-kingsway",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-pacific-medical-clinic-kingsway/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Pacific Medical Clinic (Kingsway)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8945,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0647964",
            "job_listing-clinic_lattitude": 49.2446808,
            "job_listing-job_location": "49.2446808%-123.0647964",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11153"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8945"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11153"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11153"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11153"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11153"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11153"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11153"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11152,
        "date": "2023-08-25T19:22:21",
        "date_gmt": "2023-08-25T19:22:21",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11152"
        },
        "modified": "2023-08-25T19:22:21",
        "modified_gmt": "2023-08-25T19:22:21",
        "slug": "nurse-practitioner-simply-wellness",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-simply-wellness/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Simply Wellness"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8964,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0674904",
            "job_listing-clinic_lattitude": 49.2460432,
            "job_listing-job_location": "49.2460432%-123.0674904",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11152"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11152"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11152"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11152"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11152"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11152"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11152"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11151,
        "date": "2023-08-25T19:20:37",
        "date_gmt": "2023-08-25T19:20:37",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11151"
        },
        "modified": "2023-08-25T19:20:37",
        "modified_gmt": "2023-08-25T19:20:37",
        "slug": "nurse-practitioner-yyoung-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-yyoung-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; yYoung Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9032,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1009101",
            "job_listing-clinic_lattitude": 49.2699771,
            "job_listing-job_location": "49.2699771%-123.1009101",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11151"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11151"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11151"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11151"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11151"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11151"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11151"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11150,
        "date": "2023-08-25T19:18:55",
        "date_gmt": "2023-08-25T19:18:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11150"
        },
        "modified": "2023-08-25T19:18:55",
        "modified_gmt": "2023-08-25T19:18:55",
        "slug": "nurse-practitioner-medical-office-on-granville-and-w-70th",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-medical-office-on-granville-and-w-70th/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Medical Office on Granville and W 70th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8785,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.140125",
            "job_listing-clinic_lattitude": 49.2088037,
            "job_listing-job_location": "49.2088037%-123.140125",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11150"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8785"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11150"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11150"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11150"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11150"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11150"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11150"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11149,
        "date": "2023-08-25T19:16:51",
        "date_gmt": "2023-08-25T19:16:51",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11149"
        },
        "modified": "2023-08-25T19:16:51",
        "modified_gmt": "2023-08-25T19:16:51",
        "slug": "nurse-practitioner-fraser-street-medical",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-fraser-street-medical/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Fraser Street Medical"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8838,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0903124",
            "job_listing-clinic_lattitude": 49.2304914,
            "job_listing-job_location": "49.2304914%-123.0903124",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11149"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8838"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11149"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11149"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11149"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11149"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11149"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11149"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11147,
        "date": "2023-08-25T19:07:53",
        "date_gmt": "2023-08-25T19:07:53",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11147"
        },
        "modified": "2023-08-25T19:07:53",
        "modified_gmt": "2023-08-25T19:07:53",
        "slug": "nurse-practitioner-oak-tree-family-medicine",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-oak-tree-family-medicine/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Oak Tree Family Medicine"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": "",
            "job_listing-clinic": 10549,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0659687",
            "job_listing-clinic_lattitude": 49.2237087,
            "job_listing-job_location": "49.2237087%-123.0659687",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11147"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10549"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11147"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11147"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11147"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11147"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11147"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11147"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11146,
        "date": "2023-08-25T19:04:40",
        "date_gmt": "2023-08-25T19:04:40",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11146"
        },
        "modified": "2023-08-25T19:14:50",
        "modified_gmt": "2023-08-25T19:14:50",
        "slug": "nurse-practitioner-dr-ps-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-dr-ps-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Dr. PS Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": "",
            "job_listing-clinic": 9049,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.101429",
            "job_listing-clinic_lattitude": 49.2248253,
            "job_listing-job_location": "49.2248253%-123.101429",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11146"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9049"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11146"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11146"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11146"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11146"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11146"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11146"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11145,
        "date": "2023-08-25T19:02:13",
        "date_gmt": "2023-08-25T19:02:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11145"
        },
        "modified": "2023-08-25T19:14:07",
        "modified_gmt": "2023-08-25T19:14:07",
        "slug": "nurse-practitioner-sina-medical-and-aesthetics-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-sina-medical-and-aesthetics-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Sina Medical and Aesthetics Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": "",
            "job_listing-clinic": 8967,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1194461",
            "job_listing-clinic_lattitude": 49.2793002,
            "job_listing-job_location": "49.2793002%-123.1194461",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11145"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8967"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11145"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11145"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11145"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11145"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11145"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11145"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11144,
        "date": "2023-08-25T19:00:11",
        "date_gmt": "2023-08-25T19:00:11",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11144"
        },
        "modified": "2023-08-25T19:12:46",
        "modified_gmt": "2023-08-25T19:12:46",
        "slug": "nurse-practitioner-south-vancouver-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-south-vancouver-medical-clinic/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; South Vancouver Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": "",
            "job_listing-clinic": 8980,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0994426",
            "job_listing-clinic_lattitude": 49.2098082,
            "job_listing-job_location": "49.2098082%-123.0994426",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11144"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8980"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11144"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11144"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11144"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11144"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11144"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11144"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11143,
        "date": "2023-08-25T18:56:15",
        "date_gmt": "2023-08-25T18:56:15",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11143"
        },
        "modified": "2023-08-25T19:11:37",
        "modified_gmt": "2023-08-25T19:11:37",
        "slug": "nurse-practitioner-tlc-medical-clinic-marine-drive",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-tlc-medical-clinic-marine-drive/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; TLC Medical Clinic (Marine Drive)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": "",
            "job_listing-clinic": 9629,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0904915",
            "job_listing-clinic_lattitude": 49.2114363,
            "job_listing-job_location": "49.2114363%-123.0904915",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11143"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9629"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11143"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11143"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11143"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11143"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11143"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11143"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11140,
        "date": "2023-08-25T18:52:07",
        "date_gmt": "2023-08-25T18:52:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11140"
        },
        "modified": "2023-08-25T19:09:23",
        "modified_gmt": "2023-08-25T19:09:23",
        "slug": "nurse-practitioner-tlc-medical-clinic-knight-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-tlc-medical-clinic-knight-st/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; TLC Medical Clinic (Knight St.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8994,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Contact for more information",
            "job_listing-remuneration": "NP Contract",
            "job_listing-description": "",
            "job_listing-job_specifics": "This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.076322",
            "job_listing-clinic_lattitude": 49.2325315,
            "job_listing-job_location": "49.2325315%-123.076322",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11140"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8994"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11140"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11140"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11140"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11140"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11140"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11140"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11125,
        "date": "2023-08-21T20:41:24",
        "date_gmt": "2023-08-21T20:41:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11125"
        },
        "modified": "2023-08-30T18:47:38",
        "modified_gmt": "2023-08-30T18:47:38",
        "slug": "permanent-family-physician-mint-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-mint-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Mint Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10901,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25 split to annual maximum; 100% panel payment (LFP or FFS) to physician",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0597165",
            "job_listing-clinic_lattitude": 49.2428127,
            "job_listing-job_location": "49.2428127%-123.0597165",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11125"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10901"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11125"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11125"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11125"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11125"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11125"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11125"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11124,
        "date": "2023-08-21T20:40:04",
        "date_gmt": "2023-08-21T20:40:04",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11124"
        },
        "modified": "2023-08-21T20:42:12",
        "modified_gmt": "2023-08-21T20:42:12",
        "slug": "locum-family-physician-mint-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-mint-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Mint Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 10901,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25 split to annual maximum; 100% panel payment (LFP or FFS) to physician.",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0597165",
            "job_listing-clinic_lattitude": 49.2428127,
            "job_listing-job_location": "49.2428127%-123.0597165",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11124"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10901"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11124"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11124"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11124"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11124"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11124"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11124"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11036,
        "date": "2023-08-14T21:48:34",
        "date_gmt": "2023-08-14T21:48:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11036"
        },
        "modified": "2023-08-14T21:48:34",
        "modified_gmt": "2023-08-14T21:48:34",
        "slug": "locum-family-physician-raven-song-community-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-raven-song-community-health-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Raven Song Community Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            189
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8951,
            "set_specific_time": true,
            "job_listing-start_date": "20230801",
            "job_listing-end_date": "20240201",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Sessional",
            "job_listing-description": "",
            "job_listing-job_specifics": "0.4-0.6 FTE",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1042735",
            "job_listing-clinic_lattitude": 49.2635524,
            "job_listing-job_location": "49.2635524%-123.1042735",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11036"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8951"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11036"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11036"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11036"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11036"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11036"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11036"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11035,
        "date": "2023-08-14T21:46:44",
        "date_gmt": "2023-08-14T21:46:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11035"
        },
        "modified": "2023-08-14T21:46:44",
        "modified_gmt": "2023-08-14T21:46:44",
        "slug": "locum-family-physician-alberni-medical-clinic-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-alberni-medical-clinic-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Alberni Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9244,
            "set_specific_time": true,
            "job_listing-start_date": "20231220",
            "job_listing-end_date": "20240112",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1281668",
            "job_listing-clinic_lattitude": 49.2879721,
            "job_listing-job_location": "49.2879721%-123.1281668",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11035"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9244"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11035"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11035"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11035"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11035"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11035"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11035"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11034,
        "date": "2023-08-14T21:45:14",
        "date_gmt": "2023-08-14T21:45:14",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11034"
        },
        "modified": "2023-08-14T21:45:14",
        "modified_gmt": "2023-08-14T21:45:14",
        "slug": "permanent-family-physician-chen-medical-and-mental-health-group",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-chen-medical-and-mental-health-group/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Chen Medical and Mental Health Group"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8833,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1170634",
            "job_listing-clinic_lattitude": 49.2328589,
            "job_listing-job_location": "49.2328589%-123.1170634",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11034"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8833"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11034"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11034"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11034"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11034"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11034"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11034"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11033,
        "date": "2023-08-14T21:44:01",
        "date_gmt": "2023-08-14T21:44:01",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11033"
        },
        "modified": "2023-08-14T21:44:01",
        "modified_gmt": "2023-08-14T21:44:01",
        "slug": "locum-family-physician-chen-medical-and-mental-health-group",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-chen-medical-and-mental-health-group/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Chen Medical and Mental Health Group"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8833,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1170634",
            "job_listing-clinic_lattitude": 49.2328589,
            "job_listing-job_location": "49.2328589%-123.1170634",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11033"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8833"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11033"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11033"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11033"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11033"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11033"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11033"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11032,
        "date": "2023-08-14T21:42:19",
        "date_gmt": "2023-08-14T21:42:19",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11032"
        },
        "modified": "2023-09-11T18:40:08",
        "modified_gmt": "2023-09-11T18:40:08",
        "slug": "locum-family-physician-pacific-medical-clinic-fraser-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-pacific-medical-clinic-fraser-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Pacific Medical Clinic (Fraser)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9305,
            "set_specific_time": false,
            "job_listing-start_date": "20230801",
            "job_listing-end_date": "20230831",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0902688",
            "job_listing-clinic_lattitude": 49.2285535,
            "job_listing-job_location": "49.2285535%-123.0902688",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11032"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9305"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11032"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11032"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11032"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11032"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11032"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11032"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 11030,
        "date": "2023-08-14T21:40:45",
        "date_gmt": "2023-08-14T21:40:45",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=11030"
        },
        "modified": "2023-09-11T18:38:24",
        "modified_gmt": "2023-09-11T18:38:24",
        "slug": "locum-family-physician-pacific-medical-clinic-kingsway",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-pacific-medical-clinic-kingsway/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Pacific Medical Clinic (Kingsway)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8945,
            "set_specific_time": false,
            "job_listing-start_date": "20230801",
            "job_listing-end_date": "20230831",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0647964",
            "job_listing-clinic_lattitude": 49.2446808,
            "job_listing-job_location": "49.2446808%-123.0647964",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11030"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8945"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11030"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11030"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11030"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11030"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11030"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11030"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10864,
        "date": "2023-07-27T20:32:38",
        "date_gmt": "2023-07-27T20:32:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10864"
        },
        "modified": "2023-08-04T18:03:28",
        "modified_gmt": "2023-08-04T18:03:28",
        "slug": "permanent-part-time-fp-for-long-term-care-panel-at-villa-carital",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-part-time-fp-for-long-term-care-panel-at-villa-carital/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Villa Carital"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10862,
            "set_specific_time": false,
            "job_listing-start_date": "20230601",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>\r\n&nbsp;",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0520852",
            "job_listing-clinic_lattitude": 49.2566507,
            "job_listing-job_location": "49.2566507%-123.0520852",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": "ltc@van-division.yarko.dev"
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10864"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10862"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10864"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10864"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10864"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10864"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10864"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10864"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10852,
        "date": "2023-07-25T19:49:23",
        "date_gmt": "2023-07-25T19:49:23",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10852"
        },
        "modified": "2023-07-25T19:49:23",
        "modified_gmt": "2023-07-25T19:49:23",
        "slug": "locum-family-physician-oakridge-medical-vancouver",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-oakridge-medical-vancouver/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Oakridge Medical Vancouver"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8942,
            "set_specific_time": true,
            "job_listing-start_date": "20240101",
            "job_listing-end_date": "20241001",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Maternity Leave - January 2024 for 9 months with the possibility to extend.\r\nMonday, Tuesday, Wednesday; Additional days can be accommodated if preferred",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1170634",
            "job_listing-clinic_lattitude": 49.2328589,
            "job_listing-job_location": "49.2328589%-123.1170634",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10852"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8942"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10852"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10852"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10852"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10852"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10852"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10852"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10851,
        "date": "2023-07-25T19:42:47",
        "date_gmt": "2023-07-25T19:42:47",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10851"
        },
        "modified": "2023-07-25T19:42:47",
        "modified_gmt": "2023-07-25T19:42:47",
        "slug": "locum-family-physician-mid-main-medical-clinic-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-mid-main-medical-clinic-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Mid-Main Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8932,
            "set_specific_time": true,
            "job_listing-start_date": "20231115",
            "job_listing-end_date": "20240115",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 90% forms",
            "job_listing-description": "",
            "job_listing-job_specifics": "2 days per week with flexibility to add more days if preferred",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1012107",
            "job_listing-clinic_lattitude": 49.265259,
            "job_listing-job_location": "49.265259%-123.1012107",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10851"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8932"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10851"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10851"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10851"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10851"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10851"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10851"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10850,
        "date": "2023-07-25T19:39:38",
        "date_gmt": "2023-07-25T19:39:38",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10850"
        },
        "modified": "2023-07-25T19:39:38",
        "modified_gmt": "2023-07-25T19:39:38",
        "slug": "locum-family-physician-ultima-medicentre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-ultima-medicentre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Ultima Medicentre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8997,
            "set_specific_time": true,
            "job_listing-start_date": "20231117",
            "job_listing-end_date": "20231201",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "65/35",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1214363",
            "job_listing-clinic_lattitude": 49.2864943,
            "job_listing-job_location": "49.2864943%-123.1214363",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10850"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8997"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10850"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10850"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10850"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10850"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10850"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10850"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10709,
        "date": "2023-06-30T20:48:16",
        "date_gmt": "2023-06-30T20:48:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10709"
        },
        "modified": "2023-06-30T20:48:16",
        "modified_gmt": "2023-06-30T20:48:16",
        "slug": "permanent-family-physician-highroads-medical-clinic-broadway-cambie",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-highroads-medical-clinic-broadway-cambie/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Highroads Medical Clinic (Broadway &#038; Cambie)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8862,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1165484",
            "job_listing-clinic_lattitude": 49.2630608,
            "job_listing-job_location": "49.2630608%-123.1165484",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10709"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8862"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10709"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10709"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10709"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10709"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10709"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10709"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10708,
        "date": "2023-06-30T20:47:33",
        "date_gmt": "2023-06-30T20:47:33",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10708"
        },
        "modified": "2023-07-15T18:07:08",
        "modified_gmt": "2023-07-15T18:07:08",
        "slug": "locum-family-physician-highroads-medical-clinic-broadway-cambie",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-highroads-medical-clinic-broadway-cambie/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Highroads Medical Clinic (Broadway &#038; Cambie)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8862,
            "set_specific_time": true,
            "job_listing-start_date": "20230715",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1165484",
            "job_listing-clinic_lattitude": 49.2630608,
            "job_listing-job_location": "49.2630608%-123.1165484",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10708"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8862"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10708"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10708"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10708"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10708"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10708"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10708"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10704,
        "date": "2023-06-30T19:04:46",
        "date_gmt": "2023-06-30T19:04:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10704"
        },
        "modified": "2023-07-25T22:16:41",
        "modified_gmt": "2023-07-25T22:16:41",
        "slug": "permanent-family-physician-promis-medical-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-promis-medical-centre/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Promis Medical Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10702,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, negotiable to 0%. Qualifying physicians interested in joining the clinic full-time will be offered a lucrative signing bonus",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1299861",
            "job_listing-clinic_lattitude": 49.2905367,
            "job_listing-job_location": "49.2905367%-123.1299861",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10704"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10702"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10704"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10704"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10704"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10704"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10704"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10704"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10703,
        "date": "2023-06-30T19:04:08",
        "date_gmt": "2023-06-30T19:04:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10703"
        },
        "modified": "2023-06-30T19:04:08",
        "modified_gmt": "2023-06-30T19:04:08",
        "slug": "locum-family-physician-promis-medical-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-promis-medical-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Promis Medical Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 10702,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1299861",
            "job_listing-clinic_lattitude": 49.2905367,
            "job_listing-job_location": "49.2905367%-123.1299861",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10703"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10702"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10703"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10703"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10703"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10703"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10703"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10703"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10683,
        "date": "2023-06-27T21:38:55",
        "date_gmt": "2023-06-27T21:38:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10683"
        },
        "modified": "2023-06-27T21:38:55",
        "modified_gmt": "2023-06-27T21:38:55",
        "slug": "locum-family-physician-woodland-family-practice-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-woodland-family-practice-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Woodland Family Practice"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9626,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.05629",
            "job_listing-clinic_lattitude": 49.2708927,
            "job_listing-job_location": "49.2708927%-123.05629",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10683"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9626"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10683"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10683"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10683"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10683"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10683"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10683"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10682,
        "date": "2023-06-27T21:37:40",
        "date_gmt": "2023-06-27T21:37:40",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10682"
        },
        "modified": "2023-08-21T19:13:59",
        "modified_gmt": "2023-08-21T19:13:59",
        "slug": "locum-family-physician-lotus-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-lotus-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Lotus Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8894,
            "set_specific_time": false,
            "job_listing-start_date": "20230801",
            "job_listing-end_date": "20230831",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "2-5 days per week",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0758294",
            "job_listing-clinic_lattitude": 49.2496366,
            "job_listing-job_location": "49.2496366%-123.0758294",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10682"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8894"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10682"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10682"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10682"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10682"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10682"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10682"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10681,
        "date": "2023-06-27T21:35:49",
        "date_gmt": "2023-06-27T21:35:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10681"
        },
        "modified": "2023-06-27T21:35:49",
        "modified_gmt": "2023-06-27T21:35:49",
        "slug": "locum-family-physician-john-ruedy-clinic-at-st-pauls-hospital",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-john-ruedy-clinic-at-st-pauls-hospital/",
        "title": {
            "rendered": "Locum Family Physician &#8211; John Ruedy Clinic at St. Paul&#8217;s Hospital"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9923,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Sessional",
            "job_listing-description": "",
            "job_listing-job_specifics": "2 positions available. 1 full day per week, or alternately 2 half days per week, to a maximum of 2 days per week.\r\nPhysicians will be fully supported by a comprehensive interdisciplinary team and attach a longitudinal panel of patients. The successful candidate will be Licentiates of the Medical Council of Canada and hold a current BC Medical License with the College of Physicians &amp; Surgeons of BC (CPSBC) and meet credentialing requirements at PHC (this includes sign-ff from the applicant's respective Department Head). Applicants with experience in addiction medicine and or HIV medicine will be prioritized. Educational opportunities are available for interested candidates without HIV medicine expertise. Experience working with multidisciplinary teams is an asset.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1282326",
            "job_listing-clinic_lattitude": 49.2805247,
            "job_listing-job_location": "49.2805247%-123.1282326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10681"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9923"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10681"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10681"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10681"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10681"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10681"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10681"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10679,
        "date": "2023-06-27T21:33:10",
        "date_gmt": "2023-06-27T21:33:10",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10679"
        },
        "modified": "2023-06-27T21:33:25",
        "modified_gmt": "2023-06-27T21:33:25",
        "slug": "10679",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/10679/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Medical Office on Granville and W 70th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8785,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.140125",
            "job_listing-clinic_lattitude": 49.2088037,
            "job_listing-job_location": "49.2088037%-123.140125",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10679"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8785"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10679"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10679"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10679"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10679"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10679"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10679"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10678,
        "date": "2023-06-27T21:31:36",
        "date_gmt": "2023-06-27T21:31:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10678"
        },
        "modified": "2023-06-27T21:31:36",
        "modified_gmt": "2023-06-27T21:31:36",
        "slug": "locum-family-physician-ting-medical-clinic-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-ting-medical-clinic-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Ting Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8992,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Tuesday, Thursday and Friday afternoons, ongoing",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1250251",
            "job_listing-clinic_lattitude": 49.2637081,
            "job_listing-job_location": "49.2637081%-123.1250251",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10678"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8992"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10678"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10678"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10678"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10678"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10678"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10678"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10676,
        "date": "2023-06-27T21:28:17",
        "date_gmt": "2023-06-27T21:28:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10676"
        },
        "modified": "2023-06-27T21:28:17",
        "modified_gmt": "2023-06-27T21:28:17",
        "slug": "locum-family-physician-marpole-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-marpole-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Marpole Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8927,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $100 hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1408284",
            "job_listing-clinic_lattitude": 49.2075155,
            "job_listing-job_location": "49.2075155%-123.1408284",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10676"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8927"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10676"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10676"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10676"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10676"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10676"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10676"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10662,
        "date": "2023-06-26T16:08:22",
        "date_gmt": "2023-06-26T16:08:22",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10662"
        },
        "modified": "2023-09-08T15:24:18",
        "modified_gmt": "2023-09-08T15:24:18",
        "slug": "mid-level-moa-reach-community-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/mid-level-moa-reach-community-health-centre/",
        "title": {
            "rendered": "Mid-Level MOA &#8211; REACH Community Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            202
        ],
        "joblisting_clinic_type": [
            189
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Clinic Staff",
            "job_listing-job_type": [
                "Mid-Level MOA"
            ],
            "job_listing-clinic": 8952,
            "set_specific_time": false,
            "job_listing-start_date": "20230529",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "The MOA contributes to all aspects of clinic operations and patient care, providing detailed and pro-active administrative and clinical support to patients and colleagues in a team-based environment. Working to full scope, the MOA is committed to supporting the provision of longitudinal primary care to patients with complex health and social needs, and approaches this task with empathy and cultural humility. The clinic is open extended hours and the post-holder may be required, in cooperation with other MOAs, to work on weekends and evenings, and in rare instances, provide short notice cover for sickness absence.\r\n\r\nThe following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Knowledge of MSP billing\r\n✓ Past Experience with MSP billing\r\n✓ certification as a Medical Office Assistant from an accredited educational institution, or equivalent\r\nexperience\r\n\r\nWorking with vulnerable and marginalized populations, taking vitals for patients",
            "job_listing-information": "",
            "job_listing-other_information": "<ul>\r\n \t<li>Immediate Support staff: Medical Office Assistants, Licensed Practical Nurses, Registered Nurses, Social\r\nWorkers, Nurse Practitioners, Physicians, Counsellors</li>\r\n \t<li>Secondary Support staff: Pharmacy, Administration, Cross-cultural Health Promoters</li>\r\n \t<li>Interdepartment activities and events</li>\r\n \t<li>Extended health benefits</li>\r\n</ul>",
            "job_listing-clinic_longitude": "-123.0698458",
            "job_listing-clinic_lattitude": 49.2744039,
            "job_listing-job_location": "49.2744039%-123.0698458",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10662"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8952"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10662"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10662"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10662"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10662"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10662"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10662"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10652,
        "date": "2023-06-23T16:57:25",
        "date_gmt": "2023-06-23T16:57:25",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10652"
        },
        "modified": "2023-09-08T15:24:56",
        "modified_gmt": "2023-09-08T15:24:56",
        "slug": "mid-level-moa-heather-medical-clinic-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/mid-level-moa-heather-medical-clinic-2/",
        "title": {
            "rendered": "Mid-Level MOA – Heather Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            202
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Clinic Staff",
            "job_listing-job_type": [
                "Mid-Level MOA"
            ],
            "job_listing-clinic": 8848,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "The following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Knowledge of MSP billing",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1204025",
            "job_listing-clinic_lattitude": 49.2630891,
            "job_listing-job_location": "49.2630891%-123.1204025",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10652"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8848"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10652"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10652"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10652"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10652"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10652"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10652"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10649,
        "date": "2023-06-22T15:27:41",
        "date_gmt": "2023-06-22T15:27:41",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10649"
        },
        "modified": "2023-09-08T15:25:13",
        "modified_gmt": "2023-09-08T15:25:13",
        "slug": "mid-level-moa-citymed",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/mid-level-moa-citymed/",
        "title": {
            "rendered": "Mid-Level MOA &#8211; CityMed"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            202
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8783,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "The following skills are essential for this position:\r\n\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\nThe following skills are considered strong assets for this position:\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Past Experience with MSP billing\r\n\r\nDuties may be amended or added to from time to time at the discretion of the clinic manager\r\n\r\ni) Patient flow – checking in, preparing, and taking patients to their exam room\r\nii) Room preparation – cleaning, tidying, restocking and otherwise preparing exam or treatment rooms as\r\nneeded before and after each patient encounter.\r\niii) Answer inquiries by phone and in person in a helpful, respectful, professional and efficient manner.\r\niv) Maintain appointment schedule and manages appointment recalls.\r\nv) Maintain relevant potions of the patient’s electronic medical record, and ensure patient information is\r\naccurate and current.\r\nvi) Ensure exam rooms are stocked appropriately.\r\nvii) Maintain patient confidentiality, as per the Employment Agreement and Confidentiality Agreement.\r\nviii) Clean and sterilize reusable equipment and instruments.\r\nix) Maintain the overall cleanliness, tidiness and organization of the Clinic.\r\nx) Perform simple patient preparation tasks such as weighing, measuring, or checking blood pressure or\r\nother vital signs, as directed; document findings in the patient’s medical record.\r\nxi) Process and submit billings for multiple payers (MSP, ICBC, WCB, etc.) and invoice and collect noninsured\r\nfees where applicable.\r\nxii) Order, receive, and stock kitchen, office and medical supplies.\r\nxiii) Maintain accurate Clinic supplies inventory.\r\nxiv) Perform any other related clinical, administrative or special tasks as required.\r\n\r\nGeneral Skills:\r\n\r\ni) Demonstrate a team-focused work ethic.\r\nii) Good written and verbal communication skills.\r\niii) Proficiency with a computer including using the internet and electronic medical records\r\niv) Speed and accuracy in performing tasks and entering data.v) Good problem-solving ability.\r\nvi) Demonstrates good judgement.\r\n\r\nClinical Skills and Abilities (training will be provided):\r\n\r\ni) Measure and document a patient’s blood pressure using an automated blood pressure cuff.\r\nii) Prepare patients and set up exam rooms for various purposes and procedures, including pap smears,\r\nexcisions, biopsies, contraceptive device insertions, lacerations, etc.\r\niii) Prepare vaccines as needed.\r\niv) Accurately measure patient height and weight (including children and infants).\r\nv) Measure head circumference for infants\r\nvi) Operate the autoclave.\r\nvii) Perform and record results for various lab tests done at the Clinic such as urine dips and pregnancy\r\ntests.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1005344",
            "job_listing-clinic_lattitude": 49.26613,
            "job_listing-job_location": "49.26613%-123.1005344",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10649"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8783"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10649"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10649"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10649"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10649"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10649"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10649"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10643,
        "date": "2023-06-20T17:43:04",
        "date_gmt": "2023-06-20T17:43:04",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10643"
        },
        "modified": "2023-06-20T17:43:04",
        "modified_gmt": "2023-06-20T17:43:04",
        "slug": "locum-family-physician-dr-kevin-yue-and-dr-an-qi-angie-xiong-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-dr-kevin-yue-and-dr-an-qi-angie-xiong-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Dr. Kevin Yue and Dr. An Qi Angie Xiong Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9053,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "",
            "job_listing-description": "",
            "job_listing-job_specifics": "1-4 Weeks through the year for vacation relief",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0657048",
            "job_listing-clinic_lattitude": 49.2339906,
            "job_listing-job_location": "49.2339906%-123.0657048",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10643"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9053"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10643"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10643"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10643"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10643"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10643"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10643"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10642,
        "date": "2023-06-20T17:40:59",
        "date_gmt": "2023-06-20T17:40:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10642"
        },
        "modified": "2023-06-20T17:40:59",
        "modified_gmt": "2023-06-20T17:40:59",
        "slug": "locum-family-physician-medical-office-on-e-10th-and-commercial",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-e-10th-and-commercial/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Medical Office on E 10th and Commercial"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8796,
            "set_specific_time": true,
            "job_listing-start_date": "20230901",
            "job_listing-end_date": "20230915",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "80/20, $800 Daily minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0685699",
            "job_listing-clinic_lattitude": 49.2612024,
            "job_listing-job_location": "49.2612024%-123.0685699",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10642"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8796"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10642"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10642"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10642"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10642"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10642"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10642"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10641,
        "date": "2023-06-20T17:39:06",
        "date_gmt": "2023-06-20T17:39:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10641"
        },
        "modified": "2023-06-20T17:39:06",
        "modified_gmt": "2023-06-20T17:39:06",
        "slug": "locum-family-physician-ubc-student-health-services",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-ubc-student-health-services/",
        "title": {
            "rendered": "Locum Family Physician &#8211; UBC Student Health Services"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8996,
            "set_specific_time": true,
            "job_listing-start_date": "20230620",
            "job_listing-end_date": "20240831",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Salaried",
            "job_listing-description": "",
            "job_listing-job_specifics": "Now-August 31, 2024 (PT at 20 hours/week)/Now-August 31, 2024 (PT at 21 hours/week)",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2457018",
            "job_listing-clinic_lattitude": 49.2643047,
            "job_listing-job_location": "49.2643047%-123.2457018",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10641"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10641"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10641"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10641"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10641"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10641"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10641"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10640,
        "date": "2023-06-20T17:36:26",
        "date_gmt": "2023-06-20T17:36:26",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10640"
        },
        "modified": "2023-09-11T18:07:31",
        "modified_gmt": "2023-09-11T18:07:31",
        "slug": "locum-family-physician-caya-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-caya-health-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; CAYA Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9729,
            "set_specific_time": false,
            "job_listing-start_date": "20230701",
            "job_listing-end_date": "20230831",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "",
            "job_listing-description": "",
            "job_listing-job_specifics": "Locum needed for 3-6 months, 2 days/week in person and 2 days/week virtual.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1161003",
            "job_listing-clinic_lattitude": 49.2608996,
            "job_listing-job_location": "49.2608996%-123.1161003",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10640"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9729"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10640"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10640"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10640"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10640"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10640"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10640"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10637,
        "date": "2023-06-20T17:29:25",
        "date_gmt": "2023-06-20T17:29:25",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10637"
        },
        "modified": "2023-06-26T22:47:27",
        "modified_gmt": "2023-06-26T22:47:27",
        "slug": "locum-family-physician-broadway-plaza-family-practice-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-broadway-plaza-family-practice-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Broadway Plaza Family Practice"
        },
        "excerpt": {
            "rendered": "<p>Multiple dates available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8751,
            "set_specific_time": true,
            "job_listing-start_date": "20230712",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% private billings",
            "job_listing-description": "",
            "job_listing-job_specifics": "July 12-19, 2023\r\nDecember 18-22, 2023",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1181345",
            "job_listing-clinic_lattitude": 49.2636573,
            "job_listing-job_location": "49.2636573%-123.1181345",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10637"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8751"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10637"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10637"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10637"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10637"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10637"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10637"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10631,
        "date": "2023-06-20T16:32:23",
        "date_gmt": "2023-06-20T16:32:23",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10631"
        },
        "modified": "2023-06-20T16:32:23",
        "modified_gmt": "2023-06-20T16:32:23",
        "slug": "locum-family-physician-homevive",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-homevive/",
        "title": {
            "rendered": "Locum Family Physician &#8211; HomeVIVE"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8865,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "$115 per home visit, $20 per phone call",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1211227",
            "job_listing-clinic_lattitude": 49.2615829,
            "job_listing-job_location": "49.2615829%-123.1211227",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10631"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8865"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10631"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10631"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10631"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10631"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10631"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10631"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10630,
        "date": "2023-06-20T16:30:34",
        "date_gmt": "2023-06-20T16:30:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10630"
        },
        "modified": "2023-06-20T16:30:34",
        "modified_gmt": "2023-06-20T16:30:34",
        "slug": "locum-family-physician-medical-office-on-davie-and-burrard",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-davie-and-burrard/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Medical Office on Davie and Burrard"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8792,
            "set_specific_time": true,
            "job_listing-start_date": "20230904",
            "job_listing-end_date": "20230922",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "80/20",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1283259",
            "job_listing-clinic_lattitude": 49.2793171,
            "job_listing-job_location": "49.2793171%-123.1283259",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10630"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8792"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10630"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10630"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10630"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10630"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10630"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10630"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10552,
        "date": "2023-06-05T23:44:31",
        "date_gmt": "2023-06-05T23:44:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10552"
        },
        "modified": "2023-06-05T23:44:31",
        "modified_gmt": "2023-06-05T23:44:31",
        "slug": "locum-family-physician-oak-tree-family-medicine",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-oak-tree-family-medicine/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Oak Tree Family Medicine"
        },
        "excerpt": {
            "rendered": "<p>Multiple Dates Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 10549,
            "set_specific_time": true,
            "job_listing-start_date": "20230815",
            "job_listing-end_date": "20230929",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "August 15th-18th, 2023\r\nSeptember 25th-29th, 2023",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0659687",
            "job_listing-clinic_lattitude": 49.2237087,
            "job_listing-job_location": "49.2237087%-123.0659687",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10552"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10549"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10552"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10552"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10552"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10552"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10552"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10552"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10551,
        "date": "2023-06-05T23:41:59",
        "date_gmt": "2023-06-05T23:41:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10551"
        },
        "modified": "2023-06-05T23:41:59",
        "modified_gmt": "2023-06-05T23:41:59",
        "slug": "locum-family-physician-medical-clinic-on-e-hastings-and-garden",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-medical-clinic-on-e-hastings-and-garden/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Medical Clinic on E Hastings and Garden"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9050,
            "set_specific_time": true,
            "job_listing-start_date": "20230905",
            "job_listing-end_date": "20230922",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for forms",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.058851",
            "job_listing-clinic_lattitude": 49.281285,
            "job_listing-job_location": "49.281285%-123.058851",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10551"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9050"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10551"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10551"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10551"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10551"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10551"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10551"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10550,
        "date": "2023-06-05T23:39:49",
        "date_gmt": "2023-06-05T23:39:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10550"
        },
        "modified": "2023-08-14T21:34:01",
        "modified_gmt": "2023-08-14T21:34:01",
        "slug": "permanent-family-physician-vancouver-family-practice-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-vancouver-family-practice-centre/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Vancouver Family Practice Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9005,
            "set_specific_time": true,
            "job_listing-start_date": "20230605",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Population Based Funding Model",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candiadates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1165465",
            "job_listing-clinic_lattitude": 49.2609085,
            "job_listing-job_location": "49.2609085%-123.1165465",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10550"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9005"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10550"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10550"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10550"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10550"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10550"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10550"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10548,
        "date": "2023-06-05T23:35:49",
        "date_gmt": "2023-06-05T23:35:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10548"
        },
        "modified": "2023-06-05T23:35:49",
        "modified_gmt": "2023-06-05T23:35:49",
        "slug": "permanent-family-physician-oak-tree-family-medicine",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-oak-tree-family-medicine/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Oak Tree Family Medicine"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10549,
            "set_specific_time": true,
            "job_listing-start_date": "20230605",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "No on call or after-hours requirements. Clinic offers flexible hours and workdays with doctors on staff willing to mentor new to practice physicians if desired. Cross coverage is available.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0659687",
            "job_listing-clinic_lattitude": 49.2237087,
            "job_listing-job_location": "49.2237087%-123.0659687",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10548"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10549"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10548"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10548"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10548"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10548"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10548"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10548"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10547,
        "date": "2023-06-05T23:31:48",
        "date_gmt": "2023-06-05T23:31:48",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10547"
        },
        "modified": "2023-06-05T23:31:48",
        "modified_gmt": "2023-06-05T23:31:48",
        "slug": "locum-family-physician-heather-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-heather-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Heather Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8848,
            "set_specific_time": true,
            "job_listing-start_date": "20230605",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Approximately 5 hours per week",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1204025",
            "job_listing-clinic_lattitude": 49.2630891,
            "job_listing-job_location": "49.2630891%-123.1204025",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10547"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8848"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10547"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10547"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10547"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10547"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10547"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10547"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10510,
        "date": "2023-05-25T18:44:16",
        "date_gmt": "2023-05-25T18:44:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10510"
        },
        "modified": "2023-09-08T15:25:41",
        "modified_gmt": "2023-09-08T15:25:41",
        "slug": "senior-moa-care-point-medical-and-wellness",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/senior-moa-care-point-medical-and-wellness/",
        "title": {
            "rendered": "Senior MOA &#8211; Care Point Medical and Wellness"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            204
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Clinic Staff",
            "job_listing-job_type": [
                "Senior MOA"
            ],
            "job_listing-clinic": 8758,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "The following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing",
            "job_listing-information": "",
            "job_listing-other_information": "Duties:\r\n\r\n-Anticipate and complete all administrative duties for medical staff\r\n-Maintain reception area\r\n-Scheduling and confirming appointments\r\n-Manage office inventory and equipment; anticipate needed supplies and order them accordingly\r\n-Maintaining updated and accurate patient records\r\n-Provides exceptional customer service at all times, to patients, visitors and colleagues\r\n-Ensure that the examination rooms are always clean and stocked, prepare examinations in advance.\r\n-Submit MSP, ICBC, and WCB Billings\r\n-Review and Submit private and MSP refusals and rejections\r\n-Create and maintain, staff schedules, provider schedules and day sheets\r\n-Perform daily, weekly, and monthly bookkeeping\r\n-Support training of new staff and providers\r\n-Any other related responsibilities that are within the scope and competence of the Senior Medical Office Assistant\r\n\r\nQualifications and Skills:\r\n\r\n- Certification as a Medical Office Assistant from an accredited educational institution\r\n- A minimum of 4 years practical experience in a similar roles\r\n- Excellent knowledge of Medical Terminology\r\n- Experience in using EMR (INPUT)\r\n- Communicates well and can work collaboratively with team members a patients\r\n- Ability to multi-task and prioritize duties\r\n- Punctual and Professional\r\n\r\nAdditional Practice Information\r\n<ul>\r\n \t<li>This office currently has 3 MOA's, 2 Nurse Practitioners, and 1 Full Time Physician and 1 Part time Physician.</li>\r\n \t<li>Benefits: Causal Dress, On site parking, Transit Accessible, Dental care, Extended health care, Flexible schedule, Paid time off</li>\r\n</ul>",
            "job_listing-clinic_longitude": "-123.0319535",
            "job_listing-clinic_lattitude": 49.2378195,
            "job_listing-job_location": "49.2378195%-123.0319535",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10510"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10510"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10510"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10510"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10510"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10510"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10510"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10409,
        "date": "2023-05-18T22:03:51",
        "date_gmt": "2023-05-18T22:03:51",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10409"
        },
        "modified": "2023-09-08T15:25:59",
        "modified_gmt": "2023-09-08T15:25:59",
        "slug": "mid-level-moa-reach-community-health-cenre-urgent-primary-care-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/mid-level-moa-reach-community-health-cenre-urgent-primary-care-centre/",
        "title": {
            "rendered": "Mid-Level MOA &#8211; REACH Community Health Centre UPCC"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            202
        ],
        "joblisting_clinic_type": [
            189,
            188
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Clinic Staff",
            "job_listing-job_type": [
                "Mid-Level MOA"
            ],
            "job_listing-clinic": 8956,
            "set_specific_time": false,
            "job_listing-start_date": "20230529",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "This position provides team-based care and works to full scope as an MOA. The MOA performs job duties through a trauma informed care framework and culturally sensitive and safe lens for families and individuals. Reporting to the Operations Manager, the MOA contributes to the operations of the UPCC through administrative and clinical support to our care providers in a team-based environment. Together with the interprofessional team they will play an important role in assessing urgency, and deciding on who the most appropriate team member is to meet their needs. The MOA will have the opportunity to work flexible hours on evenings and weekends.\r\n\r\nThe following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Good organizational and time management skills\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Experience in a Family Practice office\r\n✓ Past EMR experience\r\n\r\nCertification as a Medical Office Assistant from an accredited educational institution, or equivalent experience.",
            "job_listing-information": "",
            "job_listing-other_information": "<ul>\r\n \t<li>Immediate Support staff: Medical Office Assistants, Licensed Practical Nurses, Registered Nurses, Social Workers, Nurse Practitioners, Physicians</li>\r\n \t<li>Secondary Support staff: Pharmacy, administration</li>\r\n \t<li>Interdepartment activities and events</li>\r\n \t<li>Extended Health Benefits</li>\r\n</ul>",
            "job_listing-clinic_longitude": "-123.0698458",
            "job_listing-clinic_lattitude": 49.2744039,
            "job_listing-job_location": "49.2744039%-123.0698458",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10409"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8956"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10409"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10409"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10409"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10409"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10409"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10409"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10312,
        "date": "2023-05-08T18:13:13",
        "date_gmt": "2023-05-08T18:13:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10312"
        },
        "modified": "2023-06-30T19:26:20",
        "modified_gmt": "2023-06-30T19:26:20",
        "slug": "locum-family-physician-mid-main-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-mid-main-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Mid-Main Medical Clinic"
        },
        "excerpt": {
            "rendered": "<p>Multiple dates available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            189
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8932,
            "set_specific_time": true,
            "job_listing-start_date": "20230701",
            "job_listing-end_date": "20231031",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 90% forms",
            "job_listing-description": "",
            "job_listing-job_specifics": "Physicians can choose to cover July 1-October 31, 2023, or partial dates at their preference.\r\n\r\nJuly 8-16, 2023\r\nJuly 17-21, 2023\r\nJuly 22-30, 2023\r\nJuly 22-August 7, 2023\r\nJuly 24-August 18, 2023\r\nAugust 8-11, 2023\r\nAugust 10-24, 2023\r\nAugust 29-September 6, 2023\r\nSeptember 8-October 1, 2023\r\nSeptember 9-25, 2023\r\nSeptember 11-October 13, 2023",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1012107",
            "job_listing-clinic_lattitude": 49.265259,
            "job_listing-job_location": "49.265259%-123.1012107",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10312"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8932"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10312"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10312"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10312"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10312"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10312"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10312"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10311,
        "date": "2023-05-08T17:58:55",
        "date_gmt": "2023-05-08T17:58:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10311"
        },
        "modified": "2023-05-08T17:58:55",
        "modified_gmt": "2023-05-08T17:58:55",
        "slug": "locum-family-physician-khatsahlano-medical-clinic-3",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-khatsahlano-medical-clinic-3/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Khatsahlano Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8884,
            "set_specific_time": true,
            "job_listing-start_date": "20230918",
            "job_listing-end_date": "20231015",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": " 75/25 direct care and private patients, 85/15 indirect care",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1658517",
            "job_listing-clinic_lattitude": 49.264274,
            "job_listing-job_location": "49.264274%-123.1658517",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10311"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10311"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10311"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10311"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10311"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10311"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10311"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10310,
        "date": "2023-05-08T17:56:52",
        "date_gmt": "2023-05-08T17:56:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10310"
        },
        "modified": "2023-05-08T17:56:52",
        "modified_gmt": "2023-05-08T17:56:52",
        "slug": "locum-family-physician-care-point-medical-clinic-davie-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-care-point-medical-clinic-davie-st/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Care Point Medical Clinic (Davie St.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8756,
            "set_specific_time": true,
            "job_listing-start_date": "20230508",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30 Weekdays, 75/25 Weekends",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1313165",
            "job_listing-clinic_lattitude": 49.2807463,
            "job_listing-job_location": "49.2807463%-123.1313165",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10310"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10310"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10310"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10310"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10310"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10310"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10310"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10309,
        "date": "2023-05-08T17:55:13",
        "date_gmt": "2023-05-08T17:55:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10309"
        },
        "modified": "2023-05-08T17:57:13",
        "modified_gmt": "2023-05-08T17:57:13",
        "slug": "permanent-family-physician-care-point-medical-clinic-davie-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-care-point-medical-clinic-davie-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Care Point Medical Clinic (Davie St.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8756,
            "set_specific_time": true,
            "job_listing-start_date": "20230508",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30 Weekdays, 75/25 Weekends",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1313165",
            "job_listing-clinic_lattitude": 49.2807463,
            "job_listing-job_location": "49.2807463%-123.1313165",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10309"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10309"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10309"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10309"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10309"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10309"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10309"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10308,
        "date": "2023-05-08T17:52:05",
        "date_gmt": "2023-05-08T17:52:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10308"
        },
        "modified": "2023-05-08T17:52:05",
        "modified_gmt": "2023-05-08T17:52:05",
        "slug": "locum-family-physician-care-point-medical-clinic-commercial-dr",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-care-point-medical-clinic-commercial-dr/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Care Point Medical Clinic (Commercial Dr.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8754,
            "set_specific_time": true,
            "job_listing-start_date": "20230508",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30 weekdays, 75/25 weekends",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.069817",
            "job_listing-clinic_lattitude": 49.2701651,
            "job_listing-job_location": "49.2701651%-123.069817",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10308"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8754"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10308"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10308"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10308"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10308"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10308"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10308"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10255,
        "date": "2023-05-01T21:55:57",
        "date_gmt": "2023-05-01T21:55:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10255"
        },
        "modified": "2023-09-08T15:26:12",
        "modified_gmt": "2023-09-08T15:26:12",
        "slug": "junior-moa-care-point-medical-wellness",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/junior-moa-care-point-medical-wellness/",
        "title": {
            "rendered": "Junior MOA &#8211; Care Point Medical &#038; Wellness"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            200
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Clinic Staff",
            "job_listing-job_type": [
                "Junior MOA"
            ],
            "job_listing-clinic": 8756,
            "set_specific_time": false,
            "job_listing-start_date": "20230508",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "Regular MOAs duties, answering the phone, registering patients, assisting physicians.\r\n\r\nSkills &amp; Experience:\r\nThe following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Knowledge of MSP billing\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Past Experience with MSP billing",
            "job_listing-information": "",
            "job_listing-other_information": "We have 2 F/T MOAs and a clinic manager.  Extended medical after 3 months.",
            "job_listing-clinic_longitude": "-123.1313165",
            "job_listing-clinic_lattitude": 49.2807463,
            "job_listing-job_location": "49.2807463%-123.1313165",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": "Job seekers applying for Clinic Staff positions are invited to upload their resume using the \"Select files\" option below."
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10255"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10255"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10255"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10255"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10255"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10255"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10255"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10029,
        "date": "2023-04-07T00:31:39",
        "date_gmt": "2023-04-07T00:31:39",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10029"
        },
        "modified": "2023-08-09T20:51:30",
        "modified_gmt": "2023-08-09T20:51:30",
        "slug": "nurse-practitioner-pacific-medical-clinic-grandview",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/nurse-practitioner-pacific-medical-clinic-grandview/",
        "title": {
            "rendered": "Nurse Practitioner &#8211; Pacific Medical Clinic (Grandview)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            132
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Nurse Practitioner",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8944,
            "set_specific_time": true,
            "job_listing-start_date": "20230406",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "",
            "job_listing-description": "",
            "job_listing-job_specifics": "<p style=\"margin-bottom: 0in;\">This Vancouver clinic is looking to include a Nurse Practitioner to join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</p>\r\n<p style=\"margin-bottom: 0in;\">This will be a full-time salaried position. To cover overhead costs, the Ministry has allocated additional funding for the clinic. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</p>\r\n<p style=\"margin-bottom: 0in;\">Interested candidates should apply to this posting or email the Vancouver Division at <a style=\"overflow-wrap: break-word;\" title=\"mailto:recruitment@van-division.yarko.dev\" href=\"mailto:recruitment@van-division.yarko.dev\" target=\"_blank\" rel=\"noopener\" aria-label=\"Link recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a></p>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0367346",
            "job_listing-clinic_lattitude": 49.2589696,
            "job_listing-job_location": "49.2589696%-123.0367346",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10029"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8944"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10029"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10029"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10029"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10029"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10029"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10029"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10028,
        "date": "2023-04-07T00:30:02",
        "date_gmt": "2023-04-07T00:30:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10028"
        },
        "modified": "2023-05-02T23:08:49",
        "modified_gmt": "2023-05-02T23:08:49",
        "slug": "locum-family-physician-bayswater-family-practice-4",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice-4/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Bayswater Family Practice"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8745,
            "set_specific_time": true,
            "job_listing-start_date": "20231218",
            "job_listing-end_date": "20240112",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1715196",
            "job_listing-clinic_lattitude": 49.2644675,
            "job_listing-job_location": "49.2644675%-123.1715196",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10028"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10028"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10028"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10028"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10028"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10028"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10028"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10024,
        "date": "2023-04-06T17:55:55",
        "date_gmt": "2023-04-06T17:55:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10024"
        },
        "modified": "2023-09-08T15:26:49",
        "modified_gmt": "2023-09-08T15:26:49",
        "slug": "mid-level-moa-ubc-student-health-services",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/mid-level-moa-ubc-student-health-services/",
        "title": {
            "rendered": "Mid-Level MOA &#8211; UBC Student Health Services"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            202
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Clinic Staff",
            "job_listing-job_type": [
                "Mid-Level MOA"
            ],
            "job_listing-clinic": 8996,
            "set_specific_time": true,
            "job_listing-start_date": "20230501",
            "job_listing-end_date": "20240501",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "Within the context of a client centred model of care and in accordance with the vision\r\nand values of the VP Students portfolio, the Secretary to Medical Professionals is part of a team\r\nproviding a full range of clerical services in the support of client care. The position performs\r\nclerical/reception functions such as scheduling, and data entry. Duties range form routine to complex\r\nand include maintaining a highly confidential electronic medical record system, correspondence and\r\ncommunication. The Secretary to Medical Professionals receives payments, prepares financial and\r\nstatistical reports, types and prepares a variety of reports and other materials utilizing computer systems and software relevant to the job. Maintains an inventory of stationery and medical supplies. This position requires good judgment, the ability to work cooperatively in a fast paced environment, and the ability to respond with tact and sensitivity to a variety of patients and to perform all the duties with strict confidentiality.\r\n\r\n<em>Organizational Status</em>\r\nWorks under the direction and reports to the Manager. Takes instructions from director, manager and physicians.\r\n\r\n<em>Work Performed</em>\r\n<em>1. Customer Service</em>\r\n\r\nProvides efficient seamless and accessible reception service as demonstrated by:\r\nResponding respectfully and sensitively, to a culturally diverse stakeholder population (students, faculty, staff, colleagues, parents, and campus visitors).\r\nEffective verbal and nonverbal communication (welcoming and warm manner, empathic listening, ability to clarify and assess what is being asked, speaking clearly and articulately, ability to diffuse situations involving ill, anxious, or frustrated individuals\r\nEffective written communication (ability to clarify and assess what is being requested, responding\r\nconcisely, accurately, and articulately in writing to email inquiries and correspondence.\r\nProviding timely service with minimal supervision and working effectively during high volume periods.\r\nWorking collaboratively within a service team context to ensure high standards of service provision in\r\naccordance with Student Health Service policies.\r\n\r\n<em>Deals with customer service complaints effectively as demonstrated by:</em>\r\nCollaborating with parties involved to address difficulties.\r\nNegotiating positive outcomes.\r\nDetermines the urgency of requests for services and works closely with the Manager to  manage smooth flow of patients.\r\nSchedules appointments for physicians and nurses.\r\nCommunicates with other clinical offices, departments and units to coordinate client appointments and testing.\r\nRegisters students for appointments and obtains and enters data into computerized electronic medical record system.\r\nVerifies student registration status and health insurance status using established computerized database systems.\r\nAssists students in using the electronic medical record system.\r\nReceives, scans and imports and transfers diagnostic reports from external laboratories to clinic medical record system\r\nResponds to requests for records and information releasing information to authorized personnel in\r\naccordance with established standards and guidelines and procedures.\r\nTranscription of physician clinical notes, reports and letters.\r\n\r\n<em>2. Financial Support</em>\r\nReviews physician and nursing billing and diagnostic code entries for errors and omissions and corrects accordingly.\r\nReviews patient medical forms for completion (Workers Compensation Board of BC, Insurance\r\nCompanies, 3rd Party Medicals, etc) and bills accordingly.\r\nProcesses Medical/Legal requests and bills accordingly.\r\nPrepares billing claims and performs electronic transmission and retrieval of claims to Health Insurance Agencies.\r\nReconciles, reviews and makes necessary corrections of computerized claims (i.e. rejections,\r\nadjustments, payless and on hold claims).\r\nPrepares and mails invoices for patient and private insurance company accounts.\r\nProcesses receipts for incoming payments by cash, cheques and electronic transactions.\r\nPrepares cash and cheque deposits.\r\nFollow up and cost recovery of outstanding accounts.\r\nMaintains equipment rental logs and mails invoices on overdue accounts.\r\nMaintains billing and diagnostic code files for the purpose of patient billing.\r\nCompiles financial reports utilizing word processing and spreadsheet software.\r\nResponds to oral and written patient billing inquiries.\r\nPrepares and/or performs data entry of financial documents (cash deposits, journal vouchers, invoices, travel claims, etc)\r\nAssists the Manager with maintaining, reconciling and reporting financial records by recording in word processing and spreadsheet software.\r\nMaintains and files purchase requisitions, invoices and supporting documents.\r\nPrepares invoices to external businesses, organizations, agencies, prepares journal vouchers for internal charges for services, rendered to various university departments.\r\n\r\n<em>3. Administrative Support</em>\r\nProvides a full range of administrative support and duties associated with the care of patients at Student Health Service.\r\nTypes a variety of materials from draft copy, formats and edits electronic drafts using a variety of\r\ncomputer applications.\r\nPhotocopies and faxes a wide variety of forms and documents.\r\nAssists with preparation of protocol and procedure manuals.\r\nEnsures that clinical, reception and waiting room space are well maintained ensuring that office supplies and information materials are stocked.\r\nSorts and distributes mail and incoming faxes.\r\nMaintains photocopiers, printer, and video equipment.\r\nPrepares statistical reports on patient contacts to clinic.\r\nMaintains an inventory of stationary and medical supplies.\r\nPrepares data tapes for electronic medical record back up system, reviews computer logs and reports\r\ndiscrepancies to unit Manager.\r\nFiles miscellaneous documents\r\n\r\n<em>4. Communications</em>\r\nScreens and responds accurately to a variety of in-person, written and oral inquiries of an interpretive\r\nnature and provides referral information for students as appropriate.\r\nProvides accurate and clear information to the public, students and the university community regarding health and wellness services as well as other campus resources.\r\nProvides medical information within the boundaries of training and protocols of the unit.\r\nMaintains strict confidentiality of student information and medical records.\r\n\r\n<em>5. Clinical Support</em>\r\nEnsures clinical examination rooms are well maintained ensuring that medical and stationary supplies are stocked.\r\nOrganizes equipment and examination rooms for diagnostic procedures and treatments as required.\r\nPerforms minor diagnostic procedures and testing as requested by physicians or nurses.\r\nAttends medical examinations on request by physician.\r\nSubmits requests for medical and stationary supplies to unit Manager.\r\nCleaning and sterilization of medical equipment and instruments.\r\n\r\n<em>6. General Office Duties</em>\r\nPerforms other duties as required.\r\nThis position requires the ability to function in all areas of the department. This position requires direct interaction with patients and medical personal on a daily basis. The incumbent has frequent exposure to minor and major disagreeable conditions such as biomedical and non-biomedical wastes. Tasks are completed under pressure with frequent interruptions.\r\n\r\n<em>Consequence of Error/Judgement</em>\r\nAll information must be accurate and provided in a respectful, timely and supportive way. Failure to\r\nprovide service that meets these standards may impact negatively on access to services, jeopardize\r\nstudent s wellbeing, and result in increased risk to the university. Errors or incorrect decisions could\r\nresult in direct costs, lost opportunities, delays for students and staff. Damage to the unit s and to the\r\nUniversity s reputation may occur if the incumbent does not deal tactfully and helpfully with students,\r\nparents, faculty members and others.\r\n\r\n<em>Supervision Received</em>\r\nWorks cooperatively in a team environment under the supervision of the manager. Sets priorities and\r\nperforms most duties independently, occasionally consulting manager with reference to new or complex problems. Reports problems, discrepancies and office issues to the Manager.\r\nSupervision Given\r\nWorks cooperatively with other employees.",
            "job_listing-information": "",
            "job_listing-other_information": "<em>Minimum Qualifications</em>\r\nHigh school graduation, plus one year of post secondary education, plus completion of a Medical or\r\nDental Office Assistant program (including terminology), plus three years of related experience, or an\r\nequivalent combination of education and experience.\r\n\r\n<em>Preferred Qualifications</em>\r\nWithout Medical Office Assistant training three year's related experience in a medical office or clinic.\r\nMedical terminology required.\r\nAbility to use word processing, spreadsheet, database, scheduling and electronic mail applications at an intermediate level.\r\nProficiency with electronic medical records.\r\nAbility to prioritize, organize and work effectively under pressure.\r\nAbility to exercise tact and discretion when handling sensitive and/or confidential matters.\r\nDemonstrates clear understanding of confidentiality in the medical work place.\r\nAbility to maintain accuracy and attention to detail.\r\nAbility to compose routine correspondence using clear, concise medical English.\r\nAbility to work both independently and within a team environment.\r\nAbility to deal with a diversity of people in a calm, courteous, and effective manner.\r\nAbility to build rapport and provide service to people who are experiencing stress, pain and health\r\nconcerns.\r\nAbility to communicate effectively and concisely verbally and in writing.\r\nAbility to provide quality service to customers in a courteous, patient manner.\r\nAbility to effectively manage multiple tasks and priorities within a fast paced, high volume clinical area.\r\nAbility to perform basic arithmetic including calculating clinic charges, taking payments, making change\r\nand keeping accurate sales records.\r\nMust be able to reconcile daily transactions with electronic and cash receipts.\r\nAbility to accurately transcribe medical dictation.\r\nFamiliarity with MSP and other billing procedures.",
            "job_listing-clinic_longitude": "-123.2457018",
            "job_listing-clinic_lattitude": 49.2643047,
            "job_listing-job_location": "49.2643047%-123.2457018",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": "Job seekers applying for Clinic Staff positions are invited to upload their resume using the \"Select files\" option below."
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10024"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10024"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10024"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10024"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10024"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10024"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10024"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10003,
        "date": "2023-04-05T05:14:12",
        "date_gmt": "2023-04-05T05:14:12",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10003"
        },
        "modified": "2023-08-04T18:01:30",
        "modified_gmt": "2023-08-04T18:01:30",
        "slug": "blenheim-lodge",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/blenheim-lodge/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Blenheim Lodge"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10002,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1792919",
            "job_listing-clinic_lattitude": 49.257381,
            "job_listing-job_location": "49.257381%-123.1792919",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10003"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10002"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10003"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10003"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10003"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10003"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10003"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10003"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 10000,
        "date": "2023-04-04T18:29:09",
        "date_gmt": "2023-04-04T18:29:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=10000"
        },
        "modified": "2023-09-08T15:27:25",
        "modified_gmt": "2023-09-08T15:27:25",
        "slug": "junior-moa-westcoast-family-medicine",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/junior-moa-westcoast-family-medicine/",
        "title": {
            "rendered": "Junior MOA &#8211; Westcoast Family Medicine"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            181
        ],
        "joblisting_job_type": [
            200
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Clinic Staff",
            "job_listing-job_type": [
                "Junior MOA"
            ],
            "job_listing-clinic": 9024,
            "set_specific_time": false,
            "job_listing-start_date": "20230501",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Dependent on experience",
            "job_listing-description": "",
            "job_listing-job_specifics": "An incoming MOA will greet patients, identify their needs, direct patients to exam rooms, book appointments, follow up referrals, book investigations, and perform EMR filing of import box. The MOA will also be tasked with answering the phones and support 2-3 family physicians in this busy, fast-paced work environment. A Junior MOA is expected to get know our patients and understand their needs.\r\n\r\nThe following skills are essential for this position:\r\n\r\n✓ Must have an MOA certificate\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Good organizational and time management skills\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing\r\n\r\nFriendly able to multitask and remain kind\r\n\r\nPlease attach your CV below to be considered for this position.\r\n\r\n&nbsp;",
            "job_listing-information": "",
            "job_listing-other_information": "This team-based family practice environment has three other MOAs and includes staff perks such as coffee Friday and staff appreciation days.",
            "job_listing-clinic_longitude": "-123.0568593",
            "job_listing-clinic_lattitude": 49.2732643,
            "job_listing-job_location": "49.2732643%-123.0568593",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10000"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9024"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10000"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10000"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10000"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10000"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10000"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10000"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9992,
        "date": "2023-04-03T19:11:24",
        "date_gmt": "2023-04-03T19:11:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9992"
        },
        "modified": "2023-04-20T17:30:02",
        "modified_gmt": "2023-04-20T17:30:02",
        "slug": "locum-family-physician-seymour-health-centre-hornby-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-seymour-health-centre-hornby-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Seymour Health Centre (Hornby)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8962,
            "set_specific_time": true,
            "job_listing-start_date": "20230901",
            "job_listing-end_date": "20240228",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "The physician has roughly 1000 patients on their panel with a wide variety of patient types. The incoming locum will have access to 2 exam rooms and is free to create a schedule that works for them from Monday to Friday between 7:30am and 5:00pm, full or part time, and can see walk-in patients if desired.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1293994",
            "job_listing-clinic_lattitude": 49.2774715,
            "job_listing-job_location": "49.2774715%-123.1293994",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": "Job seekers applying for Clinic Staff positions are invited to upload their resume using the \"Select files\" option below."
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9992"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8962"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9992"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9992"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9992"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9992"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9992"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9992"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9930,
        "date": "2023-03-24T22:02:00",
        "date_gmt": "2023-03-24T22:02:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9930"
        },
        "modified": "2023-04-25T22:13:45",
        "modified_gmt": "2023-04-25T22:13:45",
        "slug": "locum-family-physician-seymour-health-centre-hornby",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-seymour-health-centre-hornby/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Seymour Health Centre (Hornby)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8962,
            "set_specific_time": true,
            "job_listing-start_date": "20230324",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Flexible Locum for Primary Care Clinic",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1293994",
            "job_listing-clinic_lattitude": 49.2774715,
            "job_listing-job_location": "49.2774715%-123.1293994",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9930"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8962"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9930"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9930"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9930"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9930"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9930"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9930"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9924,
        "date": "2023-03-24T18:21:37",
        "date_gmt": "2023-03-24T18:21:37",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9924"
        },
        "modified": "2023-04-25T22:13:57",
        "modified_gmt": "2023-04-25T22:13:57",
        "slug": "permanent-family-physician-john-ruedy-clinic-st-pauls-hospital",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-john-ruedy-clinic-st-pauls-hospital/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; John Ruedy Clinic, St. Paul&#8217;s Hospital"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9923,
            "set_specific_time": true,
            "job_listing-start_date": "20230324",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Physicians receive a blended compensation through either Medical Services Plan billing or hospital sessional support for services provided",
            "job_listing-description": "",
            "job_listing-job_specifics": "2 Permanent physicians needed - 1 full day per week, or alternately 2 half days per week, to a maximum of 2 days per week. Physicians will be fully supported by a comprehensive interdisciplinary team and attach a longitudinal panel of patients. The successful candidate will be Licentiates of the Medical Council of Canada and hold a current BC Medical License with the College of Physicians &amp; Surgeons of BC (CPSBC) and meet credentialing requirements at PHC (this includes sign-ff from the applicant's respective Department Head). Applicants with experience in addiction medicine and or HIV medicine will be prioritized. Educational opportunities are available for interested candidates without HIV medicine expertise. Experience working with multidisciplinary teams is an asset.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1282326",
            "job_listing-clinic_lattitude": 49.2805247,
            "job_listing-job_location": "49.2805247%-123.1282326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9924"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9923"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9924"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9924"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9924"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9924"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9924"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9924"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9782,
        "date": "2023-03-16T17:40:34",
        "date_gmt": "2023-03-16T17:40:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9782"
        },
        "modified": "2023-04-25T22:14:16",
        "modified_gmt": "2023-04-25T22:14:16",
        "slug": "permanent-family-physician-forward-care-medical-clinic-east-vancouver-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-forward-care-medical-clinic-east-vancouver-2/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Forward Care Medical Clinic (East Vancouver)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8836,
            "set_specific_time": true,
            "job_listing-start_date": "20231003",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for medical/legal reports",
            "job_listing-description": "",
            "job_listing-job_specifics": "Starting in October 2023",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0504595",
            "job_listing-clinic_lattitude": 49.2326142,
            "job_listing-job_location": "49.2326142%-123.0504595",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9782"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8836"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9782"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9782"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9782"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9782"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9782"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9782"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9731,
        "date": "2023-03-14T15:46:16",
        "date_gmt": "2023-03-14T15:46:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9731"
        },
        "modified": "2023-06-05T21:42:41",
        "modified_gmt": "2023-06-05T21:42:41",
        "slug": "permanent-family-physician-caya-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-caya-health-centre/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; CAYA Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9729,
            "set_specific_time": true,
            "job_listing-start_date": "20230501",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "Full and part time opportunities available. There is space for 1 physician to be working at a time, with access to 2 rooms during their shift; A full-time physician can expect to see 25-35 patients per day.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1161003",
            "job_listing-clinic_lattitude": 49.2608996,
            "job_listing-job_location": "49.2608996%-123.1161003",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9731"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9729"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9731"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9731"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9731"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9731"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9731"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9731"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9683,
        "date": "2023-03-10T22:19:11",
        "date_gmt": "2023-03-10T22:19:11",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9683"
        },
        "modified": "2023-09-11T18:03:10",
        "modified_gmt": "2023-09-11T18:03:10",
        "slug": "locum-family-physician-bayswater-family-practice-3",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice-3/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Bayswater Family Practice"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8745,
            "set_specific_time": true,
            "job_listing-start_date": "20231218",
            "job_listing-end_date": "20240105",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Locum coverage needed 2.5-3 days per week. There are 20-25 patients booked per day with a mix of virtual and in person appointments. The physician's patient panel is full spectrum with primarily young to middle-aged families, some elderly patients, and very few complex patients.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1715196",
            "job_listing-clinic_lattitude": 49.2644675,
            "job_listing-job_location": "49.2644675%-123.1715196",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9683"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9683"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9683"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9683"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9683"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9683"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9683"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9682,
        "date": "2023-03-10T22:16:12",
        "date_gmt": "2023-03-10T22:16:12",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9682"
        },
        "modified": "2023-04-25T22:15:58",
        "modified_gmt": "2023-04-25T22:15:58",
        "slug": "locum-family-physician-broadway-plaza-family-practice",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-broadway-plaza-family-practice/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Broadway Plaza Family Practice"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8751,
            "set_specific_time": true,
            "job_listing-start_date": "20230922",
            "job_listing-end_date": "20231004",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% private billings",
            "job_listing-description": "",
            "job_listing-job_specifics": "Monday, Tuesday, Wednesday and Friday",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1181345",
            "job_listing-clinic_lattitude": 49.2636573,
            "job_listing-job_location": "49.2636573%-123.1181345",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9682"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8751"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9682"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9682"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9682"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9682"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9682"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9682"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9646,
        "date": "2023-03-08T17:08:46",
        "date_gmt": "2023-03-08T17:08:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9646"
        },
        "modified": "2023-05-08T18:51:21",
        "modified_gmt": "2023-05-08T18:51:21",
        "slug": "permanent-family-physician-takeover-medical-office-on-41st-and-cambie",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-41st-and-cambie/",
        "title": {
            "rendered": "Permanent Family Physician (Takeover) &#8211; Medical Office on 41st and Cambie"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10316,
            "set_specific_time": true,
            "job_listing-start_date": "20231101",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "The patient population is primarily female with specialties in obstetrics and pediatrics, with some patients speaking Cantonese or Mandarin.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9646"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10316"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9646"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9646"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9646"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9646"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9646"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9646"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9645,
        "date": "2023-03-08T17:05:57",
        "date_gmt": "2023-03-08T17:05:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9645"
        },
        "modified": "2023-05-08T18:43:14",
        "modified_gmt": "2023-05-08T18:43:14",
        "slug": "permanent-family-physician-takeover-medical-office-on-kingsway-and-joyce",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-kingsway-and-joyce/",
        "title": {
            "rendered": "Permanent Family Physician (Takeover) &#8211; Medical Office on Kingsway and Joyce"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10313,
            "set_specific_time": true,
            "job_listing-start_date": "20230701",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, negotiable hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "Panel takeover starting July, 2023. 0.7 FTE, locum trial period accepted.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9645"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10313"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9645"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9645"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9645"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9645"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9645"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9645"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9641,
        "date": "2023-03-08T00:32:53",
        "date_gmt": "2023-03-08T00:32:53",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9641"
        },
        "modified": "2023-05-08T18:48:54",
        "modified_gmt": "2023-05-08T18:48:54",
        "slug": "permanent-family-physician-takeover-medical-office-on-laurel-and-8th",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-laurel-and-8th/",
        "title": {
            "rendered": "Permanent Family Physician (Takeover) &#8211; Medical Office on Laurel and 8th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8889,
            "set_specific_time": true,
            "job_listing-start_date": "20230307",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "This practice does not require obstetrics but has the option to do prenatal care and obstetrical delivery as well as minor surgeries if the new FP has interest. The retiring FP practices in English and Chinese and although experience with Chinese is not essential it would be an asset.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1234119",
            "job_listing-clinic_lattitude": 49.2640253,
            "job_listing-job_location": "49.2640253%-123.1234119",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9641"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8889"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9641"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9641"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9641"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9641"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9641"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9641"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9639,
        "date": "2023-03-08T00:25:50",
        "date_gmt": "2023-03-08T00:25:50",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9639"
        },
        "modified": "2023-05-08T18:57:39",
        "modified_gmt": "2023-05-08T18:57:39",
        "slug": "permanent-family-physician-takeover-medical-office-on-burrard-and-davie",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-burrard-and-davie/",
        "title": {
            "rendered": "Permanent Family Physician (Takeover) &#8211; Medical Office on Burrard and Davie"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10318,
            "set_specific_time": true,
            "job_listing-start_date": "20240101",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "The current physician sees an average of 30+ patients per day. Proficiency in Russian or Polish is considered an asset, however, it is not required.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9639"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10318"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9639"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9639"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9639"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9639"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9639"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9639"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9638,
        "date": "2023-03-08T00:21:49",
        "date_gmt": "2023-03-08T00:21:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9638"
        },
        "modified": "2023-05-08T18:54:53",
        "modified_gmt": "2023-05-08T18:54:53",
        "slug": "permanent-family-physician-takeover-medical-office-on-kingsway-and-baldwin",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-kingsway-and-baldwin/",
        "title": {
            "rendered": "Permanent Family Physician (Takeover) &#8211; Medical Office on Kingsway and Baldwin"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 10317,
            "set_specific_time": true,
            "job_listing-start_date": "20230901",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9638"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/10317"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9638"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9638"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9638"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9638"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9638"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9638"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9637,
        "date": "2023-03-07T23:08:55",
        "date_gmt": "2023-03-07T23:08:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9637"
        },
        "modified": "2023-08-04T18:41:23",
        "modified_gmt": "2023-08-04T18:41:23",
        "slug": "permanent-family-physician-tlc-medical-clinic-fraser",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-tlc-medical-clinic-fraser/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; TLC Medical Clinic (Marine Drive)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9629,
            "set_specific_time": true,
            "job_listing-start_date": "20230307",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0904915",
            "job_listing-clinic_lattitude": 49.2114363,
            "job_listing-job_location": "49.2114363%-123.0904915",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9637"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9629"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9637"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9637"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9637"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9637"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9637"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9637"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9636,
        "date": "2023-03-07T23:07:39",
        "date_gmt": "2023-03-07T23:07:39",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9636"
        },
        "modified": "2023-03-07T23:07:39",
        "modified_gmt": "2023-03-07T23:07:39",
        "slug": "locum-family-physician-tlc-medical-clinic-fraser",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-tlc-medical-clinic-fraser/",
        "title": {
            "rendered": "Locum Family Physician &#8211; TLC Medical Clinic (Fraser)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9629,
            "set_specific_time": true,
            "job_listing-start_date": "20230307",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0904915",
            "job_listing-clinic_lattitude": 49.2114363,
            "job_listing-job_location": "49.2114363%-123.0904915",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9636"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9629"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9636"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9636"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9636"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9636"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9636"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9636"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9628,
        "date": "2023-03-07T22:13:39",
        "date_gmt": "2023-03-07T22:13:39",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9628"
        },
        "modified": "2023-07-25T18:50:37",
        "modified_gmt": "2023-07-25T18:50:37",
        "slug": "locum-family-physician-woodland-family-practice",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-woodland-family-practice/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Woodland Family Practice"
        },
        "excerpt": {
            "rendered": "<p>Multiple Dates Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9626,
            "set_specific_time": true,
            "job_listing-start_date": "20231218",
            "job_listing-end_date": "20240831",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Flexible Locum Needed - Long term and short term opportunities available/\r\nDecember 18, 2023-January 5, 2024\r\nJuly/August 2024",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.05629",
            "job_listing-clinic_lattitude": 49.2708927,
            "job_listing-job_location": "49.2708927%-123.05629",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9628"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9626"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9628"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9628"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9628"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9628"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9628"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9628"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9627,
        "date": "2023-03-07T22:11:24",
        "date_gmt": "2023-03-07T22:11:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9627"
        },
        "modified": "2023-04-25T22:17:31",
        "modified_gmt": "2023-04-25T22:17:31",
        "slug": "permanent-family-physician-woodland-family-practice",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-woodland-family-practice/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Woodland Family Practice"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9626,
            "set_specific_time": true,
            "job_listing-start_date": "20230307",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "3 days per week",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.05629",
            "job_listing-clinic_lattitude": 49.2708927,
            "job_listing-job_location": "49.2708927%-123.05629",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9627"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9626"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9627"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9627"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9627"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9627"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9627"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9627"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9615,
        "date": "2023-03-06T23:46:16",
        "date_gmt": "2023-03-06T23:46:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9615"
        },
        "modified": "2023-03-06T23:46:25",
        "modified_gmt": "2023-03-06T23:46:25",
        "slug": "permanent-family-physician-st-pauls-maternity-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-st-pauls-maternity-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; St. Paul&#8217;s Maternity Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8929,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Sessional",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1282326",
            "job_listing-clinic_lattitude": 49.2805247,
            "job_listing-job_location": "49.2805247%-123.1282326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9615"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8929"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9615"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9615"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9615"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9615"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9615"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9615"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9614,
        "date": "2023-03-06T23:37:00",
        "date_gmt": "2023-03-06T23:37:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9614"
        },
        "modified": "2023-04-25T22:17:49",
        "modified_gmt": "2023-04-25T22:17:49",
        "slug": "locum-family-physician-st-pauls-maternity-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-st-pauls-maternity-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; St. Paul&#8217;s Maternity Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8929,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": "20240229",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Sessional",
            "job_listing-description": "",
            "job_listing-job_specifics": "Maternity leave coverage - February 2023, every Wednesday alternating clinic and call for one year (day can be flexible)",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1282326",
            "job_listing-clinic_lattitude": 49.2805247,
            "job_listing-job_location": "49.2805247%-123.1282326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9614"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8929"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9614"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9614"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9614"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9614"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9614"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9614"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9611,
        "date": "2023-03-06T23:26:00",
        "date_gmt": "2023-03-06T23:26:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9611"
        },
        "modified": "2023-04-25T22:19:15",
        "modified_gmt": "2023-04-25T22:19:15",
        "slug": "permanent-family-physician-ubc-student-health-services",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-ubc-student-health-services/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; UBC Student Health Services"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8996,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Salaried ($118.69/hour + 19.2% vacation)",
            "job_listing-description": "",
            "job_listing-job_specifics": "0.5 FTE",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2457018",
            "job_listing-clinic_lattitude": 49.2643047,
            "job_listing-job_location": "49.2643047%-123.2457018",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9611"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9611"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9611"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9611"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9611"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9611"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9611"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9610,
        "date": "2023-03-06T23:24:06",
        "date_gmt": "2023-03-06T23:24:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9610"
        },
        "modified": "2023-03-27T21:10:00",
        "modified_gmt": "2023-03-27T21:10:00",
        "slug": "locum-family-physician-luma-medical-centre-society",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-luma-medical-centre-society/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Lu&#8217;Ma Medical Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8907,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Alternate Payment Model",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0563331",
            "job_listing-clinic_lattitude": 49.257386,
            "job_listing-job_location": "49.257386%-123.0563331",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9610"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8907"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9610"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9610"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9610"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9610"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9610"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9610"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9607,
        "date": "2023-03-06T23:16:50",
        "date_gmt": "2023-03-06T23:16:50",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9607"
        },
        "modified": "2023-05-02T23:12:48",
        "modified_gmt": "2023-05-02T23:12:48",
        "slug": "locum-family-physician-fraser-street-medical",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-fraser-street-medical/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Fraser Street Medical"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8838,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Ongoing needs, multiple dates available",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0903124",
            "job_listing-clinic_lattitude": 49.2304914,
            "job_listing-job_location": "49.2304914%-123.0903124",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9607"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8838"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9607"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9607"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9607"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9607"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9607"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9607"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9606,
        "date": "2023-03-06T23:08:15",
        "date_gmt": "2023-03-06T23:08:15",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9606"
        },
        "modified": "2023-04-25T22:19:35",
        "modified_gmt": "2023-04-25T22:19:35",
        "slug": "locum-family-physician-medical-office-on-laurel-and-8th",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-laurel-and-8th/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Medical Office on Laurel and 8th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8794,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Christmas, New Years, and Spring Break coverage preferred",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1234119",
            "job_listing-clinic_lattitude": 49.2640253,
            "job_listing-job_location": "49.2640253%-123.1234119",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9606"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8794"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9606"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9606"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9606"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9606"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9606"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9606"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9605,
        "date": "2023-03-06T23:04:29",
        "date_gmt": "2023-03-06T23:04:29",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9605"
        },
        "modified": "2023-04-25T22:19:45",
        "modified_gmt": "2023-04-25T22:19:45",
        "slug": "permanent-family-physician-medical-office-on-nanaimo-and-pender",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-nanaimo-and-pender/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Medical Office on Nanaimo and Pender"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8793,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "1-2 days per week",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0559482",
            "job_listing-clinic_lattitude": 49.2805384,
            "job_listing-job_location": "49.2805384%-123.0559482",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9605"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8793"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9605"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9605"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9605"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9605"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9605"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9605"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9604,
        "date": "2023-03-06T23:03:05",
        "date_gmt": "2023-03-06T23:03:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9604"
        },
        "modified": "2023-03-06T23:03:05",
        "modified_gmt": "2023-03-06T23:03:05",
        "slug": "permanent-family-physician-medical-office-on-laurel-and-8th",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-laurel-and-8th/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Medical Office on Laurel and 8th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8794,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Cost Sharing Agreement",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1234119",
            "job_listing-clinic_lattitude": 49.2640253,
            "job_listing-job_location": "49.2640253%-123.1234119",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9604"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8794"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9604"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9604"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9604"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9604"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9604"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9604"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9598,
        "date": "2023-03-06T21:26:46",
        "date_gmt": "2023-03-06T21:26:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9598"
        },
        "modified": "2023-04-25T22:19:57",
        "modified_gmt": "2023-04-25T22:19:57",
        "slug": "permanent-family-physician-forward-care-medical-clinic-oakridge",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-forward-care-medical-clinic-oakridge/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Forward Care Medical Clinic (Oakridge)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8834,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for medical/legal reports",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1170634",
            "job_listing-clinic_lattitude": 49.2328589,
            "job_listing-job_location": "49.2328589%-123.1170634",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9598"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8834"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9598"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9598"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9598"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9598"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9598"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9598"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9597,
        "date": "2023-03-06T21:24:44",
        "date_gmt": "2023-03-06T21:24:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9597"
        },
        "modified": "2023-07-25T17:58:44",
        "modified_gmt": "2023-07-25T17:58:44",
        "slug": "locum-family-physician-forward-care-medical-clinic-oakridge",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-forward-care-medical-clinic-oakridge/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Forward Care Medical Clinic (Oakridge)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8834,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for medical/legal reports",
            "job_listing-description": "",
            "job_listing-job_specifics": "Long term and short term opportunities available",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1170634",
            "job_listing-clinic_lattitude": 49.2328589,
            "job_listing-job_location": "49.2328589%-123.1170634",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9597"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8834"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9597"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9597"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9597"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9597"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9597"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9597"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9596,
        "date": "2023-03-06T21:22:50",
        "date_gmt": "2023-03-06T21:22:50",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9596"
        },
        "modified": "2023-03-06T21:22:50",
        "modified_gmt": "2023-03-06T21:22:50",
        "slug": "locum-family-physician-vycare-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-vycare-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; VyCare Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9007,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.026608",
            "job_listing-clinic_lattitude": 49.2323817,
            "job_listing-job_location": "49.2323817%-123.026608",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9596"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9007"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9596"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9596"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9596"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9596"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9596"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9596"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9595,
        "date": "2023-03-06T21:08:13",
        "date_gmt": "2023-03-06T21:08:13",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9595"
        },
        "modified": "2023-03-27T21:10:51",
        "modified_gmt": "2023-03-27T21:10:51",
        "slug": "permanent-family-physician-homevive-program",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-homevive-program/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Home-Vive"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8865,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "$115 per home visit, $20 per telephone call",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1211227",
            "job_listing-clinic_lattitude": 49.2615829,
            "job_listing-job_location": "49.2615829%-123.1211227",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9595"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8865"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9595"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9595"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9595"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9595"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9595"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9595"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9594,
        "date": "2023-03-06T21:06:08",
        "date_gmt": "2023-03-06T21:06:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9594"
        },
        "modified": "2023-05-04T21:56:42",
        "modified_gmt": "2023-05-04T21:56:42",
        "slug": "locum-family-physician-south-vancouver-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-south-vancouver-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; South Vancouver Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8980,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0994426",
            "job_listing-clinic_lattitude": 49.2098082,
            "job_listing-job_location": "49.2098082%-123.0994426",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9594"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8980"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9594"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9594"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9594"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9594"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9594"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9594"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9593,
        "date": "2023-03-06T21:04:36",
        "date_gmt": "2023-03-06T21:04:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9593"
        },
        "modified": "2023-05-04T22:47:41",
        "modified_gmt": "2023-05-04T22:47:41",
        "slug": "permanent-family-physician-reach-community-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-reach-community-health-centre/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Reach Community Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            189
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8952,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Alternate Payment Model",
            "job_listing-description": "",
            "job_listing-job_specifics": "The provider will see an average of 15-20 patients a day, consisting of medically and psychosocially complex care including addictions care. Addictions care patients make up approximately 5-10% of the patient panel but account for a larger proportion of the clinic’s monthly visits, however the clinic serves full-spectrum family medicine from cradle to grave. There may be house calls for homebound patients, as well as early prenatal care up to 20 weeks, however there is no obstetrics or 3rd trimester care. No inpatient hospital work required.\r\n\r\nThe incoming FP will negotiate their set weekly schedule with the CHC, and there may be some flexibility in weekly scheduling thereafter, however this will be constrained by room availability. One day a week permanent staff/MRP’s will perform Telehealth, but all new locums are always required on site.\r\n\r\nRemuneration is in the form of sessional pay, with a patient panel focus on addictions and complexity.\r\n\r\n<span style=\"text-decoration: underline;\"><strong>Qualifications include:</strong></span>\r\n<ul>\r\n \t<li>Physician registered (Full) with the College of Physicians and Surgeons of B.C.</li>\r\n \t<li>Certification with the College of Family Physicians of Canada.</li>\r\n \t<li>Commitment and ability to implement REACH’s strategic goals, mission, vision, and values.</li>\r\n \t<li>A background in working with youth, mental health, addictions, fragile families, refugees, and frail elderly desired.</li>\r\n \t<li>Current methadone exception and Suboxone certification or willingness to obtain same.</li>\r\n \t<li>An awareness of the impact of colonization on Aboriginal peoples and understanding of cultural competency as a care provider.</li>\r\n \t<li>Ability to speak more than one language is an asset.</li>\r\n \t<li>Experience or training in delivering medical education an asset.</li>\r\n \t<li>Experience or training in primary care research and policy an asset.</li>\r\n</ul>\r\n<strong>Positions: </strong>2\r\n<strong>FTE:</strong> 0.7 FTE\r\n<strong>Facility Type:</strong> Community Health Centre\r\n<strong>Health Authority:</strong> Vancouver Coastal Health\r\n<strong>Sub-specialty:</strong> Addiction Medicine\r\n<strong>Scheduling:</strong> 0.7 FTE is 3 days a week of direct patient care, including 1 evening session 5pm-8pm each week, 3.5hrs/wk administrative duties. 1hr/wk team or quality improvement meetings.\r\n<strong>On-Call Hours:</strong> Yes (Telephone on-call support after hours 1:8)\r\n<strong>Compensation:</strong> Approximately $300,000/FTE *Alternative Payment Arrangement – Service Contract 1.0 FTE = 1680hrs/year\r\n<strong>Overhead:</strong> 9.5%\r\n<strong>Benefits and/or Incentives:</strong> Vacation/Study Leave: Up to 7 weeks a year unpaid as part of service contract agreement.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0698458",
            "job_listing-clinic_lattitude": 49.2744039,
            "job_listing-job_location": "49.2744039%-123.0698458",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9593"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8952"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9593"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9593"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9593"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9593"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9593"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9593"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9592,
        "date": "2023-03-06T21:00:09",
        "date_gmt": "2023-03-06T21:00:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9592"
        },
        "modified": "2023-06-02T21:07:29",
        "modified_gmt": "2023-06-02T21:07:29",
        "slug": "locum-family-physician-reach-community-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-reach-community-health-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Reach Community Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            189
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8952,
            "set_specific_time": true,
            "job_listing-start_date": "20230801",
            "job_listing-end_date": "20230929",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Alternate Payment Model",
            "job_listing-description": "",
            "job_listing-job_specifics": "June 26-July 14 (1 locum: 3-4 days per week)\r\nAugust 1-September 29 (2 locums: up to 5 days per week)\r\n\r\nThe provider will see an average of 15-20 patients a day, consisting of medically and psychosocially complex care including addictions care. Addictions care patients make up approximately 5-10% of the patient panel but account for a larger proportion of the clinic’s monthly visits, however the clinic serves full-spectrum family medicine from cradle to grave. There may be house calls for homebound patients, as well as early prenatal care up to 20 weeks, however there is no obstetrics or 3rd trimester care. No inpatient hospital work required.\r\n\r\nRemuneration is in the form of sessional pay, with a patient panel focus on addictions and complexity.\r\n\r\n<strong>Qualifications include:</strong>\r\n<ul>\r\n \t<li>Physician registered (Full) with the College of Physicians and Surgeons of B.C.</li>\r\n \t<li>Certification with the College of Family Physicians of Canada.</li>\r\n \t<li>Commitment and ability to implement REACH’s strategic goals, mission, vision, and values.</li>\r\n \t<li>A background in working with youth, mental health, addictions, fragile families, refugees, and frail elderly desired.</li>\r\n \t<li>Current methadone exception and Suboxone certification or willingness to obtain same.</li>\r\n \t<li>An awareness of the impact of colonization on Aboriginal peoples and understanding of cultural competency as a care provider.</li>\r\n \t<li>Ability to speak more than one language is an asset.</li>\r\n \t<li>Experience or training in delivering medical education an asset.</li>\r\n \t<li>Experience or training in primary care research and policy an asset.</li>\r\n</ul>\r\n<strong>Facility Type:</strong> Community Health Centre\r\n<strong>Health Authority:</strong> Vancouver Coastal Health\r\n<strong>Sub-specialty:</strong> Addiction Medicine\r\n<strong>On-Call Hours:</strong> Yes (Telephone on-call support after hours 1:8)\r\n<strong>Overhead:</strong> 9.5%",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0698458",
            "job_listing-clinic_lattitude": 49.2744039,
            "job_listing-job_location": "49.2744039%-123.0698458",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9592"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8952"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9592"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9592"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9592"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9592"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9592"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9592"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9591,
        "date": "2023-03-06T20:55:34",
        "date_gmt": "2023-03-06T20:55:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9591"
        },
        "modified": "2023-03-06T20:55:34",
        "modified_gmt": "2023-03-06T20:55:34",
        "slug": "locum-family-physician-reach-urgent-primary-care-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-reach-urgent-primary-care-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Reach Urgent &#038; Primary Care Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            188
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8956,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "$163.39/hr. (0.8 FTE- 28 hours per week)",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0698458",
            "job_listing-clinic_lattitude": 49.2744039,
            "job_listing-job_location": "49.2744039%-123.0698458",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9591"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8956"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9591"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9591"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9591"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9591"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9591"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9591"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9589,
        "date": "2023-03-06T20:46:11",
        "date_gmt": "2023-03-06T20:46:11",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9589"
        },
        "modified": "2023-03-06T20:46:11",
        "modified_gmt": "2023-03-06T20:46:11",
        "slug": "permanent-family-physician-urban-native-youth-association",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-urban-native-youth-association/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Urban Native Youth Association"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9003,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Alternate Payment Model",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0715372",
            "job_listing-clinic_lattitude": 49.2810865,
            "job_listing-job_location": "49.2810865%-123.0715372",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9589"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9003"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9589"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9589"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9589"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9589"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9589"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9589"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9586,
        "date": "2023-03-06T20:23:17",
        "date_gmt": "2023-03-06T20:23:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9586"
        },
        "modified": "2023-04-25T22:20:45",
        "modified_gmt": "2023-04-25T22:20:45",
        "slug": "locum-family-physician-georgia-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-georgia-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Georgia Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8840,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "Wednesday and Friday shifts available - 12:30pm-4:30pm ongoing",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1342138",
            "job_listing-clinic_lattitude": 49.2924601,
            "job_listing-job_location": "49.2924601%-123.1342138",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9586"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8840"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9586"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9586"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9586"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9586"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9586"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9586"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9584,
        "date": "2023-03-06T20:16:21",
        "date_gmt": "2023-03-06T20:16:21",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9584"
        },
        "modified": "2023-08-21T19:39:38",
        "modified_gmt": "2023-08-21T19:39:38",
        "slug": "locum-family-physician-yyoung-medical-clinic-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-yyoung-medical-clinic-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; yYoung Medical Clinic"
        },
        "excerpt": {
            "rendered": "<p>Multiple Dates Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9032,
            "set_specific_time": true,
            "job_listing-start_date": "20231120",
            "job_listing-end_date": "20230430",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $100 hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "November 20-December 1, 2023\r\nMarch-April 2024 (6-8 weeks paternity leave)",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1009101",
            "job_listing-clinic_lattitude": 49.2699771,
            "job_listing-job_location": "49.2699771%-123.1009101",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9584"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9584"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9584"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9584"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9584"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9584"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9584"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9576,
        "date": "2023-03-06T20:13:05",
        "date_gmt": "2023-03-06T20:13:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9576"
        },
        "modified": "2023-04-25T22:22:13",
        "modified_gmt": "2023-04-25T22:22:13",
        "slug": "permanent-family-physician-marine-gateway-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-marine-gateway-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Marine Gateway Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9577,
            "set_specific_time": true,
            "job_listing-start_date": "20230323",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1165058",
            "job_listing-clinic_lattitude": 49.2099136,
            "job_listing-job_location": "49.2099136%-123.1165058",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9576"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9577"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9576"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9576"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9576"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9576"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9576"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9576"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9575,
        "date": "2023-03-06T20:09:52",
        "date_gmt": "2023-03-06T20:09:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9575"
        },
        "modified": "2023-03-06T20:09:52",
        "modified_gmt": "2023-03-06T20:09:52",
        "slug": "permanent-family-physician-georgia-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-georgia-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Georgia Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8840,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1342138",
            "job_listing-clinic_lattitude": 49.2924601,
            "job_listing-job_location": "49.2924601%-123.1342138",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9575"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8840"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9575"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9575"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9575"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9575"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9575"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9575"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9574,
        "date": "2023-03-06T20:08:18",
        "date_gmt": "2023-03-06T20:08:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9574"
        },
        "modified": "2023-03-06T20:08:18",
        "modified_gmt": "2023-03-06T20:08:18",
        "slug": "locum-family-physician-granville-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-granville-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Granville Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8843,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1383608",
            "job_listing-clinic_lattitude": 49.2629811,
            "job_listing-job_location": "49.2629811%-123.1383608",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9574"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8843"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9574"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9574"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9574"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9574"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9574"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9574"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9573,
        "date": "2023-03-06T20:06:50",
        "date_gmt": "2023-03-06T20:06:50",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9573"
        },
        "modified": "2023-04-25T22:22:15",
        "modified_gmt": "2023-04-25T22:22:15",
        "slug": "permanent-family-physician-vycare-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-vycare-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; VyCare Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9007,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully licensed and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.026608",
            "job_listing-clinic_lattitude": 49.2323817,
            "job_listing-job_location": "49.2323817%-123.026608",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9573"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9007"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9573"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9573"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9573"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9573"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9573"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9573"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9572,
        "date": "2023-03-06T20:04:44",
        "date_gmt": "2023-03-06T20:04:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9572"
        },
        "modified": "2023-03-06T20:04:44",
        "modified_gmt": "2023-03-06T20:04:44",
        "slug": "permanent-family-physician-queens-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-queens-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Queens Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8948,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0599773",
            "job_listing-clinic_lattitude": 49.2429212,
            "job_listing-job_location": "49.2429212%-123.0599773",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9572"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8948"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9572"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9572"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9572"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9572"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9572"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9572"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9571,
        "date": "2023-03-06T20:02:56",
        "date_gmt": "2023-03-06T20:02:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9571"
        },
        "modified": "2023-04-25T22:22:24",
        "modified_gmt": "2023-04-25T22:22:24",
        "slug": "permanent-family-physician-loyal-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-loyal-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Loyal Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8897,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1216604",
            "job_listing-clinic_lattitude": 49.285265,
            "job_listing-job_location": "49.285265%-123.1216604",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9571"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8897"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9571"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9571"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9571"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9571"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9571"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9571"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9570,
        "date": "2023-03-06T19:59:40",
        "date_gmt": "2023-03-06T19:59:40",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9570"
        },
        "modified": "2023-03-06T19:59:40",
        "modified_gmt": "2023-03-06T19:59:40",
        "slug": "locum-family-physician-little-mountain-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-little-mountain-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Little Mountain Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8890,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1165484",
            "job_listing-clinic_lattitude": 49.2630608,
            "job_listing-job_location": "49.2630608%-123.1165484",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9570"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8890"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9570"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9570"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9570"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9570"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9570"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9570"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9567,
        "date": "2023-03-06T18:57:49",
        "date_gmt": "2023-03-06T18:57:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9567"
        },
        "modified": "2023-04-25T22:22:45",
        "modified_gmt": "2023-04-25T22:22:45",
        "slug": "permanent-family-physician-well-health-medical-clinic-city-view",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-medical-clinic-city-view/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; WELL Health Medical Clinic (City View)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9010,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1196326",
            "job_listing-clinic_lattitude": 49.2635805,
            "job_listing-job_location": "49.2635805%-123.1196326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9567"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9010"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9567"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9567"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9567"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9567"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9567"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9567"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9566,
        "date": "2023-03-06T18:56:06",
        "date_gmt": "2023-03-06T18:56:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9566"
        },
        "modified": "2023-03-06T18:56:06",
        "modified_gmt": "2023-03-06T18:56:06",
        "slug": "locum-family-physician-sina-medical-and-aesthetics-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-sina-medical-and-aesthetics-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Sina Medical and Aesthetics Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8967,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1194461",
            "job_listing-clinic_lattitude": 49.2793002,
            "job_listing-job_location": "49.2793002%-123.1194461",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9566"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8967"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9566"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9566"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9566"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9566"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9566"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9566"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9564,
        "date": "2023-03-06T18:52:35",
        "date_gmt": "2023-03-06T18:52:35",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9564"
        },
        "modified": "2023-05-04T21:56:49",
        "modified_gmt": "2023-05-04T21:56:49",
        "slug": "permanent-family-physician-south-vancouver-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-south-vancouver-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; South Vancouver Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8980,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0994426",
            "job_listing-clinic_lattitude": 49.2098082,
            "job_listing-job_location": "49.2098082%-123.0994426",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9564"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8980"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9564"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9564"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9564"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9564"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9564"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9564"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9563,
        "date": "2023-03-06T18:50:27",
        "date_gmt": "2023-03-06T18:50:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9563"
        },
        "modified": "2023-03-06T18:50:27",
        "modified_gmt": "2023-03-06T18:50:27",
        "slug": "permanent-family-physician-iss-of-bc-welcome-centre-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-iss-of-bc-welcome-centre-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; ISS of BC Welcome Centre Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8868,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": "20230306",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0653303",
            "job_listing-clinic_lattitude": 49.2610006,
            "job_listing-job_location": "49.2610006%-123.0653303",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9563"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8868"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9563"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9563"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9563"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9563"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9563"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9563"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9562,
        "date": "2023-03-06T18:46:51",
        "date_gmt": "2023-03-06T18:46:51",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9562"
        },
        "modified": "2023-03-06T18:46:51",
        "modified_gmt": "2023-03-06T18:46:51",
        "slug": "locum-family-physician-iss-of-bc-welcome-centre-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-iss-of-bc-welcome-centre-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; ISS of BC Welcome Centre Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8868,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0653303",
            "job_listing-clinic_lattitude": 49.2610006,
            "job_listing-job_location": "49.2610006%-123.0653303",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9562"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8868"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9562"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9562"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9562"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9562"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9562"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9562"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9561,
        "date": "2023-03-06T18:24:58",
        "date_gmt": "2023-03-06T18:24:58",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9561"
        },
        "modified": "2023-03-06T18:25:11",
        "modified_gmt": "2023-03-06T18:25:11",
        "slug": "permanent-family-physician-pharmachoice-main",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-pharmachoice-main/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; PharmaChoice Main"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8947,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "100% of billings",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1007979",
            "job_listing-clinic_lattitude": 49.2504517,
            "job_listing-job_location": "49.2504517%-123.1007979",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9561"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8947"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9561"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9561"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9561"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9561"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9561"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9561"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9560,
        "date": "2023-03-06T18:21:55",
        "date_gmt": "2023-03-06T18:21:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9560"
        },
        "modified": "2023-04-25T22:23:14",
        "modified_gmt": "2023-04-25T22:23:14",
        "slug": "permanent-family-physician-west-10th-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-west-10th-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; West 10th Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9022,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "The clinic has space for one full time or two part time physicians\r\nOpen to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2033665",
            "job_listing-clinic_lattitude": 49.2638745,
            "job_listing-job_location": "49.2638745%-123.2033665",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9560"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9022"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9560"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9560"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9560"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9560"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9560"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9560"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9559,
        "date": "2023-03-06T18:16:31",
        "date_gmt": "2023-03-06T18:16:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9559"
        },
        "modified": "2023-05-08T22:14:39",
        "modified_gmt": "2023-05-08T22:14:39",
        "slug": "permanent-family-physician-heather-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-heather-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Heather Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8848,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "Open to both fully and provisionally licensed candidates",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1204025",
            "job_listing-clinic_lattitude": 49.2630891,
            "job_listing-job_location": "49.2630891%-123.1204025",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9559"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8848"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9559"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9559"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9559"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9559"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9559"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9559"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9558,
        "date": "2023-03-06T18:12:45",
        "date_gmt": "2023-03-06T18:12:45",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9558"
        },
        "modified": "2023-04-25T22:24:10",
        "modified_gmt": "2023-04-25T22:24:10",
        "slug": "permanent-family-physician-granville-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-granville-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Granville Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8843,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1383608",
            "job_listing-clinic_lattitude": 49.2629811,
            "job_listing-job_location": "49.2629811%-123.1383608",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9558"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8843"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9558"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9558"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9558"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9558"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9558"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9558"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9557,
        "date": "2023-03-06T18:10:53",
        "date_gmt": "2023-03-06T18:10:53",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9557"
        },
        "modified": "2023-04-25T22:24:20",
        "modified_gmt": "2023-04-25T22:24:20",
        "slug": "permanent-family-physician-sina-medical-and-aesthetics-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-sina-medical-and-aesthetics-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Sina Medical and Aesthetics Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8967,
            "set_specific_time": true,
            "job_listing-start_date": "20230306",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "Room for 1-2 fulltime physician, open to provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1194461",
            "job_listing-clinic_lattitude": 49.2793002,
            "job_listing-job_location": "49.2793002%-123.1194461",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9557"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8967"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9557"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9557"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9557"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9557"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9557"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9557"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9556,
        "date": "2023-03-04T00:35:46",
        "date_gmt": "2023-03-04T00:35:46",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9556"
        },
        "modified": "2023-03-04T00:35:46",
        "modified_gmt": "2023-03-04T00:35:46",
        "slug": "permanent-family-physician-yaletown-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-yaletown-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Yaletown Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9030,
            "set_specific_time": true,
            "job_listing-start_date": "20230303",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $100 hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1228869",
            "job_listing-clinic_lattitude": 49.2732651,
            "job_listing-job_location": "49.2732651%-123.1228869",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9556"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9030"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9556"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9556"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9556"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9556"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9556"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9556"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9554,
        "date": "2023-03-04T00:05:43",
        "date_gmt": "2023-03-04T00:05:43",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9554"
        },
        "modified": "2023-08-14T21:27:35",
        "modified_gmt": "2023-08-14T21:27:35",
        "slug": "locum-family-physician-bayswater-family-practice-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Bayswater Family Practice"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8745,
            "set_specific_time": true,
            "job_listing-start_date": "20231218",
            "job_listing-end_date": "20240104",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1715196",
            "job_listing-clinic_lattitude": 49.2644675,
            "job_listing-job_location": "49.2644675%-123.1715196",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9554"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9554"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9554"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9554"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9554"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9554"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9554"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9553,
        "date": "2023-03-04T00:03:14",
        "date_gmt": "2023-03-04T00:03:14",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9553"
        },
        "modified": "2023-07-10T22:54:18",
        "modified_gmt": "2023-07-10T22:54:18",
        "slug": "locum-family-physician-yaletown-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-yaletown-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Yaletown Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9030,
            "set_specific_time": false,
            "job_listing-start_date": "20230303",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $100 hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "Monday-Friday 9am-3pm or 3pm-8pm, Saturdays 10am-5pm\r\nLong term locum for Weekends (80/20 billing split, 3-6 months)",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1228869",
            "job_listing-clinic_lattitude": 49.2732651,
            "job_listing-job_location": "49.2732651%-123.1228869",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9553"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9030"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9553"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9553"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9553"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9553"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9553"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9553"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9551,
        "date": "2023-03-03T23:29:19",
        "date_gmt": "2023-03-03T23:29:19",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9551"
        },
        "modified": "2023-04-25T22:25:48",
        "modified_gmt": "2023-04-25T22:25:48",
        "slug": "locum-family-physician-oakridge-medical-group",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-oakridge-medical-group/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Oakridge Medical Group"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8943,
            "set_specific_time": true,
            "job_listing-start_date": "20230303",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1158391",
            "job_listing-clinic_lattitude": 49.2347432,
            "job_listing-job_location": "49.2347432%-123.1158391",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9551"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8943"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9551"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9551"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9551"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9551"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9551"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9551"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9550,
        "date": "2023-03-03T23:18:07",
        "date_gmt": "2023-03-03T23:18:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9550"
        },
        "modified": "2023-08-21T19:12:22",
        "modified_gmt": "2023-08-21T19:12:22",
        "slug": "locum-family-physician-kariba-health",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-kariba-health/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Kariba Health"
        },
        "excerpt": {
            "rendered": "<p>Multiple Dates Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8871,
            "set_specific_time": true,
            "job_listing-start_date": "20230701",
            "job_listing-end_date": "20240131",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Maternity Leave Locum - November 2023 through May/June 2024\r\nFlexible Locum to cover overflow 1-3 days per week)",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1533438",
            "job_listing-clinic_lattitude": 49.2622939,
            "job_listing-job_location": "49.2622939%-123.1533438",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9550"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8871"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9550"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9550"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9550"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9550"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9550"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9550"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9380,
        "date": "2023-02-24T00:35:18",
        "date_gmt": "2023-02-24T00:35:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9380"
        },
        "modified": "2023-04-25T22:26:10",
        "modified_gmt": "2023-04-25T22:26:10",
        "slug": "permanent-family-physician-yyoung-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-yyoung-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; yYoung Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9032,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "This clinic is seeking permanent family physicians for their walk-in clinic, or to start a patient panel.\r\nOpen to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1009101",
            "job_listing-clinic_lattitude": 49.2699771,
            "job_listing-job_location": "49.2699771%-123.1009101",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9380"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9380"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9380"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9380"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9380"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9380"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9380"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9379,
        "date": "2023-02-24T00:31:00",
        "date_gmt": "2023-02-24T00:31:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9379"
        },
        "modified": "2023-06-05T19:39:45",
        "modified_gmt": "2023-06-05T19:39:45",
        "slug": "locum-family-physician-yyoung-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-yyoung-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; yYoung Medical Clinic"
        },
        "excerpt": {
            "rendered": "<p>Multiple opportunities available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9032,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Coverage for the walk-in clinic/Overflow coverage for 2 physician's",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1009101",
            "job_listing-clinic_lattitude": 49.2699771,
            "job_listing-job_location": "49.2699771%-123.1009101",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9379"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9379"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9379"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9379"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9379"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9379"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9379"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9378,
        "date": "2023-02-24T00:28:56",
        "date_gmt": "2023-02-24T00:28:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9378"
        },
        "modified": "2023-04-25T22:26:26",
        "modified_gmt": "2023-04-25T22:26:26",
        "slug": "permanent-family-physician-medical-office-on-w-broadway-and-willow-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-w-broadway-and-willow-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Medical Office on W Broadway and Willow"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9048,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "3 Days/Week",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1250251",
            "job_listing-clinic_lattitude": 49.2637081,
            "job_listing-job_location": "49.2637081%-123.1250251",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9378"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9048"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9378"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9378"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9378"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9378"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9378"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9378"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9377,
        "date": "2023-02-24T00:26:15",
        "date_gmt": "2023-02-24T00:26:15",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9377"
        },
        "modified": "2023-09-11T18:18:25",
        "modified_gmt": "2023-09-11T18:18:25",
        "slug": "locum-family-physician-medical-office-on-w-50th-and-main-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-w-50th-and-main-st/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Dr. PS Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9049,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "1–3 month locum with the ability to extend or become permanent",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.101429",
            "job_listing-clinic_lattitude": 49.2248253,
            "job_listing-job_location": "49.2248253%-123.101429",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9377"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9049"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9377"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9377"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9377"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9377"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9377"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9377"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9376,
        "date": "2023-02-24T00:24:04",
        "date_gmt": "2023-02-24T00:24:04",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9376"
        },
        "modified": "2023-09-11T18:18:06",
        "modified_gmt": "2023-09-11T18:18:06",
        "slug": "permanent-family-physician-medical-office-on-w-50th-and-main-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-w-50th-and-main-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Dr. PS Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9049,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.101429",
            "job_listing-clinic_lattitude": 49.2248253,
            "job_listing-job_location": "49.2248253%-123.101429",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9376"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9049"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9376"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9376"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9376"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9376"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9376"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9376"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9375,
        "date": "2023-02-24T00:20:42",
        "date_gmt": "2023-02-24T00:20:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9375"
        },
        "modified": "2023-04-25T22:26:57",
        "modified_gmt": "2023-04-25T22:26:57",
        "slug": "locum-family-physician-medical-office-on-nanaimo-st-and-e-pender-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-nanaimo-st-and-e-pender-st/",
        "title": {
            "rendered": "Locum Family Physician- Medical Office on Nanaimo and E Pender"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8793,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "This clinic is seeking a locum for any 2 weeks in the year. The coverage needed would include 4 days per week with a half day on Wednesday.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0559482",
            "job_listing-clinic_lattitude": 49.2805384,
            "job_listing-job_location": "49.2805384%-123.0559482",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9375"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8793"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9375"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9375"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9375"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9375"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9375"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9375"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9374,
        "date": "2023-02-24T00:16:16",
        "date_gmt": "2023-02-24T00:16:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9374"
        },
        "modified": "2023-03-27T21:16:13",
        "modified_gmt": "2023-03-27T21:16:13",
        "slug": "permanent-family-physician-medical-office-on-dunbar-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-dunbar-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Medical Office on Dunbar and W 17th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9337,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1853382",
            "job_listing-clinic_lattitude": 49.2566473,
            "job_listing-job_location": "49.2566473%-123.1853382",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9374"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9337"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9374"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9374"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9374"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9374"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9374"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9374"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9368,
        "date": "2023-02-23T23:45:27",
        "date_gmt": "2023-02-23T23:45:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9368"
        },
        "modified": "2023-04-25T22:27:37",
        "modified_gmt": "2023-04-25T22:27:37",
        "slug": "permanent-family-physician-well-health-point-grey-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-point-grey-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; WELL Health Medical Clinic (Point Grey)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9018,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2075374",
            "job_listing-clinic_lattitude": 49.2636084,
            "job_listing-job_location": "49.2636084%-123.2075374",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9368"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9018"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9368"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9368"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9368"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9368"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9368"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9368"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9367,
        "date": "2023-02-23T23:43:36",
        "date_gmt": "2023-02-23T23:43:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9367"
        },
        "modified": "2023-03-16T18:36:43",
        "modified_gmt": "2023-03-16T18:36:43",
        "slug": "flexible-locum-family-physician-well-health-point-grey-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/flexible-locum-family-physician-well-health-point-grey-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; WELL Health Medical Clinic (Point Grey)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9018,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2075374",
            "job_listing-clinic_lattitude": 49.2636084,
            "job_listing-job_location": "49.2636084%-123.2075374",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9367"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9018"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9367"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9367"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9367"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9367"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9367"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9367"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9366,
        "date": "2023-02-23T23:41:25",
        "date_gmt": "2023-02-23T23:41:25",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9366"
        },
        "modified": "2023-03-16T18:37:00",
        "modified_gmt": "2023-03-16T18:37:00",
        "slug": "flexible-locum-family-physician-well-health-kerrisdale-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/flexible-locum-family-physician-well-health-kerrisdale-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; WELL Health Medical Clinic (Kerrisdale)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9016,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1534977",
            "job_listing-clinic_lattitude": 49.2337865,
            "job_listing-job_location": "49.2337865%-123.1534977",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9366"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9016"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9366"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9366"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9366"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9366"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9366"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9366"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9365,
        "date": "2023-02-23T23:35:59",
        "date_gmt": "2023-02-23T23:35:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9365"
        },
        "modified": "2023-04-25T22:28:42",
        "modified_gmt": "2023-04-25T22:28:42",
        "slug": "permanent-family-physician-well-health-kerrisdale-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-kerrisdale-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; WELL Health Medical Clinic (Kerrisdale)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9016,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1534977",
            "job_listing-clinic_lattitude": 49.2337865,
            "job_listing-job_location": "49.2337865%-123.1534977",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9365"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9016"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9365"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9365"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9365"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9365"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9365"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9365"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9363,
        "date": "2023-02-23T23:27:39",
        "date_gmt": "2023-02-23T23:27:39",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9363"
        },
        "modified": "2023-03-16T18:37:29",
        "modified_gmt": "2023-03-16T18:37:29",
        "slug": "flexible-locum-family-physician-well-health-hastings-sunrise-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/flexible-locum-family-physician-well-health-hastings-sunrise-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; WELL Health Medical Clinic (Hastings Sunrise)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9015,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.058289",
            "job_listing-clinic_lattitude": 49.2809177,
            "job_listing-job_location": "49.2809177%-123.058289",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9363"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9015"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9363"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9363"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9363"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9363"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9363"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9363"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9362,
        "date": "2023-02-23T23:25:59",
        "date_gmt": "2023-02-23T23:25:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9362"
        },
        "modified": "2023-03-16T18:37:37",
        "modified_gmt": "2023-03-16T18:37:37",
        "slug": "permanent-family-physician-well-health-hastings-sunrise-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-hastings-sunrise-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; WELL Health Medical Clinic (Hastings Sunrise)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9015,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.058289",
            "job_listing-clinic_lattitude": 49.2809177,
            "job_listing-job_location": "49.2809177%-123.058289",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9362"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9015"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9362"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9362"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9362"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9362"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9362"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9362"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9359,
        "date": "2023-02-23T23:19:17",
        "date_gmt": "2023-02-23T23:19:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9359"
        },
        "modified": "2023-04-25T22:29:09",
        "modified_gmt": "2023-04-25T22:29:09",
        "slug": "permanent-family-physician-seymour-health-centre-hornby-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-seymour-health-centre-hornby-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Seymour Health Centre (Hornby)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8962,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable, 70/30 billing split OR salary model available for any physicians interested",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1293994",
            "job_listing-clinic_lattitude": 49.2774715,
            "job_listing-job_location": "49.2774715%-123.1293994",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9359"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8962"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9359"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9359"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9359"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9359"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9359"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9359"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9357,
        "date": "2023-02-23T23:14:19",
        "date_gmt": "2023-02-23T23:14:19",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9357"
        },
        "modified": "2023-06-05T21:04:51",
        "modified_gmt": "2023-06-05T21:04:51",
        "slug": "locum-family-physician-seymour-health-centre-granville-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-seymour-health-centre-granville-st/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Seymour Health Centre (Granville)"
        },
        "excerpt": {
            "rendered": "<p>Multiple Opportunities Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8963,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Walk-In Locum/Flexible Locum",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1395812",
            "job_listing-clinic_lattitude": 49.2652565,
            "job_listing-job_location": "49.2652565%-123.1395812",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9357"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8963"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9357"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9357"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9357"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9357"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9357"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9357"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9354,
        "date": "2023-02-23T23:13:09",
        "date_gmt": "2023-02-23T23:13:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9354"
        },
        "modified": "2023-04-25T22:29:26",
        "modified_gmt": "2023-04-25T22:29:26",
        "slug": "permanent-family-physician-seymour-health-centre-granville-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-seymour-health-centre-granville-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Seymour Health Centre (Granville)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8963,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1395812",
            "job_listing-clinic_lattitude": 49.2652565,
            "job_listing-job_location": "49.2652565%-123.1395812",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9354"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8963"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9354"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9354"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9354"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9354"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9354"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9354"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9353,
        "date": "2023-02-23T22:54:05",
        "date_gmt": "2023-02-23T22:54:05",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9353"
        },
        "modified": "2023-03-03T22:29:19",
        "modified_gmt": "2023-03-03T22:29:19",
        "slug": "permanent-family-physician-marpole-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-marpole-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Marpole Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8927,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $100 hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9353"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8927"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9353"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9353"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9353"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9353"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9353"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9353"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9351,
        "date": "2023-02-23T22:50:07",
        "date_gmt": "2023-02-23T22:50:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9351"
        },
        "modified": "2023-04-25T22:29:35",
        "modified_gmt": "2023-04-25T22:29:35",
        "slug": "permanent-family-physician-mariners-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-mariners-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Mariners Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8926,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "65/35",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1283259",
            "job_listing-clinic_lattitude": 49.2793171,
            "job_listing-job_location": "49.2793171%-123.1283259",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9351"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8926"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9351"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9351"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9351"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9351"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9351"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9351"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9350,
        "date": "2023-02-23T22:36:37",
        "date_gmt": "2023-02-23T22:36:37",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9350"
        },
        "modified": "2023-04-25T22:29:44",
        "modified_gmt": "2023-04-25T22:29:44",
        "slug": "locum-family-physician-khatsahlano-medical-clinic-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-khatsahlano-medical-clinic-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Khatsahlano Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8884,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25 direct care and private patients, 85/15 indirect care, 100% of billings for admin and annual patient panel payment",
            "job_listing-description": "",
            "job_listing-job_specifics": "Monday-Sunday shifts available",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1658517",
            "job_listing-clinic_lattitude": 49.264274,
            "job_listing-job_location": "49.264274%-123.1658517",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9350"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9350"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9350"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9350"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9350"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9350"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9350"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9325,
        "date": "2023-02-23T22:34:23",
        "date_gmt": "2023-02-23T22:34:23",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9325"
        },
        "modified": "2023-03-21T16:30:31",
        "modified_gmt": "2023-03-21T16:30:31",
        "slug": "locum-family-physician-khatsahlano-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-khatsahlano-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Khatsahlano Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8884,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25 direct care and private patients, 85/15 indirect care, 100% of billings for admin and annual patient panel payment",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1658517",
            "job_listing-clinic_lattitude": 49.264274,
            "job_listing-job_location": "49.264274%-123.1658517",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9325"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9325"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9325"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9325"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9325"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9325"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9325"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9340,
        "date": "2023-02-23T21:50:00",
        "date_gmt": "2023-02-23T21:50:00",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9340"
        },
        "modified": "2023-07-25T17:34:07",
        "modified_gmt": "2023-07-25T17:34:07",
        "slug": "locum-family-physician-bayswater-family-practice",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Bayswater Family Practice"
        },
        "excerpt": {
            "rendered": "<p>Multiple Dates Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8745,
            "set_specific_time": false,
            "job_listing-start_date": "20230601",
            "job_listing-end_date": "20230930",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Saturday Mornings (2-4 per month)",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1715196",
            "job_listing-clinic_lattitude": 49.2644675,
            "job_listing-job_location": "49.2644675%-123.1715196",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9340"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9340"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9340"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9340"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9340"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9340"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9340"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9339,
        "date": "2023-02-23T21:46:55",
        "date_gmt": "2023-02-23T21:46:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9339"
        },
        "modified": "2023-05-02T23:01:23",
        "modified_gmt": "2023-05-02T23:01:23",
        "slug": "permanent-family-physician-bayswater-family-practice",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-bayswater-family-practice/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Bayswater Family Practice"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8745,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1715196",
            "job_listing-clinic_lattitude": 49.2644675,
            "job_listing-job_location": "49.2644675%-123.1715196",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9339"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9339"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9339"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9339"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9339"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9339"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9339"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9336,
        "date": "2023-02-23T21:33:24",
        "date_gmt": "2023-02-23T21:33:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9336"
        },
        "modified": "2023-03-03T22:29:19",
        "modified_gmt": "2023-03-03T22:29:19",
        "slug": "locum-family-physician-medical-office-on-dunbar-and-w-17th",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-dunbar-and-w-17th/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Medical Office on Dunbar and W 17th"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9337,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9336"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9337"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9336"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9336"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9336"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9336"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9336"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9336"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9335,
        "date": "2023-02-23T21:29:37",
        "date_gmt": "2023-02-23T21:29:37",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9335"
        },
        "modified": "2023-03-03T22:29:19",
        "modified_gmt": "2023-03-03T22:29:19",
        "slug": "permanent-family-physician-salish-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-salish-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Salish Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8961,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9335"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8961"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9335"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9335"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9335"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9335"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9335"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9335"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9334,
        "date": "2023-02-23T21:24:49",
        "date_gmt": "2023-02-23T21:24:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9334"
        },
        "modified": "2023-08-21T19:36:38",
        "modified_gmt": "2023-08-21T19:36:38",
        "slug": "locum-family-physician-vancouver-family-practice-centre-2",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-vancouver-family-practice-centre-2/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Vancouver Family Practice Centre"
        },
        "excerpt": {
            "rendered": "<p>Multiple Dates Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9005,
            "set_specific_time": true,
            "job_listing-start_date": "20230901",
            "job_listing-end_date": "20240115",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Population Based Funding Model",
            "job_listing-description": "September 1, 2023-January 15, 2024 (2 days per week)\r\n\r\nLong-term Locum to cover overflow for multiple physicians in the practice. This opportunity can be full time or part time, and hours are flexible between 8:30am and 6pm Monday through Thursday, 8:30am-5pm Fridays, and 10am-2pm Saturdays.  These are typical family practices with a range of ages and illness, with no special focus. Patients are scheduled every 15 minutes or longer when needed.\r\n\r\nDecember/Christmas locum to cover overflow for multiple physicians in the practice. This opportunity can be full time or part time, with a combination of in person and virtual visits.",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1165465",
            "job_listing-clinic_lattitude": 49.2609085,
            "job_listing-job_location": "49.2609085%-123.1165465",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9334"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9005"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9334"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9334"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9334"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9334"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9334"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9334"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9330,
        "date": "2023-02-23T21:12:18",
        "date_gmt": "2023-02-23T21:12:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9330"
        },
        "modified": "2023-06-05T20:21:38",
        "modified_gmt": "2023-06-05T20:21:38",
        "slug": "locum-family-physician-vancouver-aboriginal-health-society",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-vancouver-aboriginal-health-society/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Vancouver Aboriginal Health Society"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9004,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Sessional",
            "job_listing-description": "",
            "job_listing-job_specifics": "Ongoing needs for day, Wednesday evening, and Saturday shifts. Full or half days available.\r\n\r\nThe clinic is looking for physicians who can provide trauma-informed, culturally competent care to their specific patient population. Interested candidates must have a methadone license and be competent in prescribing opioid agonist therapy.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0942149",
            "job_listing-clinic_lattitude": 49.2814816,
            "job_listing-job_location": "49.2814816%-123.0942149",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9330"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9004"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9330"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9330"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9330"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9330"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9330"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9330"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9329,
        "date": "2023-02-23T21:09:29",
        "date_gmt": "2023-02-23T21:09:29",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9329"
        },
        "modified": "2023-04-25T22:32:06",
        "modified_gmt": "2023-04-25T22:32:06",
        "slug": "locum-family-physician-una-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-una-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; UNA Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9002,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $100 hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "Long term opportunity",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1274989",
            "job_listing-clinic_lattitude": 49.257934,
            "job_listing-job_location": "49.257934%-123.1274989",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9329"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9002"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9329"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9329"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9329"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9329"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9329"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9329"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9328,
        "date": "2023-02-23T21:07:52",
        "date_gmt": "2023-02-23T21:07:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9328"
        },
        "modified": "2023-04-25T22:32:15",
        "modified_gmt": "2023-04-25T22:32:15",
        "slug": "permanent-family-physician-una-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-una-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; UNA Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9002,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $100 hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1274989",
            "job_listing-clinic_lattitude": 49.257934,
            "job_listing-job_location": "49.257934%-123.1274989",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9328"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9002"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9328"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9328"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9328"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9328"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9328"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9328"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9327,
        "date": "2023-02-23T21:05:57",
        "date_gmt": "2023-02-23T21:05:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9327"
        },
        "modified": "2023-03-03T22:29:19",
        "modified_gmt": "2023-03-03T22:29:19",
        "slug": "permanent-family-physician-total-care-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-total-care-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Total Care Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8911,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9327"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8911"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9327"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9327"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9327"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9327"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9327"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9327"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9326,
        "date": "2023-02-23T21:04:07",
        "date_gmt": "2023-02-23T21:04:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9326"
        },
        "modified": "2023-03-03T22:29:19",
        "modified_gmt": "2023-03-03T22:29:19",
        "slug": "locum-family-physician-tlc-medical-clinic-knight-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-tlc-medical-clinic-knight-st/",
        "title": {
            "rendered": "Locum Family Physician &#8211; TLC Medical Clinic (Knight St.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8994,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9326"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8994"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9326"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9326"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9326"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9326"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9326"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9326"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9324,
        "date": "2023-02-23T21:03:02",
        "date_gmt": "2023-02-23T21:03:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9324"
        },
        "modified": "2023-04-25T22:32:31",
        "modified_gmt": "2023-04-25T22:32:31",
        "slug": "permanent-family-physician-tlc-medical-clinic-knight-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-tlc-medical-clinic-knight-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; TLC Medical Clinic (Knight St.)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8994,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.076322",
            "job_listing-clinic_lattitude": 49.2325315,
            "job_listing-job_location": "49.2325315%-123.076322",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9324"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8994"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9324"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9324"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9324"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9324"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9324"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9324"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9322,
        "date": "2023-02-23T21:02:17",
        "date_gmt": "2023-02-23T21:02:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9322"
        },
        "modified": "2023-04-25T22:32:41",
        "modified_gmt": "2023-04-25T22:32:41",
        "slug": "permanent-family-physician-khatsahlano-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-khatsahlano-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Khatsahlano Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8884,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25 direct care and private patients, 85/15 indirect care, 100% of billings for admin and annual patient panel payment",
            "job_listing-description": "",
            "job_listing-job_specifics": "Shifts are available Monday to Sunday, 9:00am to 5:00pm.\r\nThis opportunity is open to fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1658517",
            "job_listing-clinic_lattitude": 49.264274,
            "job_listing-job_location": "49.264274%-123.1658517",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9322"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9322"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9322"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9322"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9322"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9322"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9322"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9323,
        "date": "2023-02-23T21:01:31",
        "date_gmt": "2023-02-23T21:01:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9323"
        },
        "modified": "2023-05-12T12:46:59",
        "modified_gmt": "2023-05-12T12:46:59",
        "slug": "permanent-family-physician-tlc-medical-clinic-granville",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-tlc-medical-clinic-granville/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; TLC Medical Clinic (Granville)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8993,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 90/10 on private and out of office work",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1409633",
            "job_listing-clinic_lattitude": 49.2195936,
            "job_listing-job_location": "49.2195936%-123.1409633",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9323"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8993"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9323"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9323"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9323"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9323"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9323"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9323"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9321,
        "date": "2023-02-23T20:59:27",
        "date_gmt": "2023-02-23T20:59:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9321"
        },
        "modified": "2023-03-03T22:30:02",
        "modified_gmt": "2023-03-03T22:30:02",
        "slug": "locum-family-physician-tlc-medical-clinic-granville",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-tlc-medical-clinic-granville/",
        "title": {
            "rendered": "Locum Family Physician &#8211; TLC Medical Clinic (Granville)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8993,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 90/10 on private and out of office work",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9321"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8993"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9321"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9321"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9321"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9321"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9321"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9321"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9319,
        "date": "2023-02-23T20:42:03",
        "date_gmt": "2023-02-23T20:42:03",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9319"
        },
        "modified": "2023-03-03T22:30:02",
        "modified_gmt": "2023-03-03T22:30:02",
        "slug": "locum-family-physician-south-hill-family-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-south-hill-family-health-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; South Hill Family Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8975,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": "20231231",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9319"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8975"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9319"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9319"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9319"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9319"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9319"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9319"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9318,
        "date": "2023-02-23T20:39:23",
        "date_gmt": "2023-02-23T20:39:23",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9318"
        },
        "modified": "2023-05-04T21:48:35",
        "modified_gmt": "2023-05-04T21:48:35",
        "slug": "locum-family-physician-sky-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-sky-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Sky Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8974,
            "set_specific_time": true,
            "job_listing-start_date": "20230301",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1283259",
            "job_listing-clinic_lattitude": 49.2793171,
            "job_listing-job_location": "49.2793171%-123.1283259",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9318"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8974"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9318"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9318"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9318"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9318"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9318"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9318"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9298,
        "date": "2023-02-23T20:36:34",
        "date_gmt": "2023-02-23T20:36:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9298"
        },
        "modified": "2023-03-27T21:26:26",
        "modified_gmt": "2023-03-27T21:26:26",
        "slug": "locum-family-physician-keefer-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-keefer-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Keefer Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8878,
            "set_specific_time": true,
            "job_listing-start_date": "20230327",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "80/20, $1000 daily minimum (8 hour shift)",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1013456",
            "job_listing-clinic_lattitude": 49.2793542,
            "job_listing-job_location": "49.2793542%-123.1013456",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9298"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8878"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9298"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9298"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9298"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9298"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9298"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9298"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9316,
        "date": "2023-02-23T20:36:21",
        "date_gmt": "2023-02-23T20:36:21",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9316"
        },
        "modified": "2023-05-04T21:48:52",
        "modified_gmt": "2023-05-04T21:48:52",
        "slug": "permanent-family-physician-sky-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-sky-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Sky Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8974,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1283259",
            "job_listing-clinic_lattitude": 49.2793171,
            "job_listing-job_location": "49.2793171%-123.1283259",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9316"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8974"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9316"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9316"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9316"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9316"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9316"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9316"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9315,
        "date": "2023-02-23T20:34:27",
        "date_gmt": "2023-02-23T20:34:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9315"
        },
        "modified": "2023-07-25T18:38:34",
        "modified_gmt": "2023-07-25T18:38:34",
        "slug": "locum-family-physician-simply-wellness-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-simply-wellness-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Simply Wellness Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8964,
            "set_specific_time": false,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0674904",
            "job_listing-clinic_lattitude": 49.2460432,
            "job_listing-job_location": "49.2460432%-123.0674904",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9315"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9315"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9315"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9315"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9315"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9315"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9315"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9314,
        "date": "2023-02-23T20:32:30",
        "date_gmt": "2023-02-23T20:32:30",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9314"
        },
        "modified": "2023-04-25T22:33:45",
        "modified_gmt": "2023-04-25T22:33:45",
        "slug": "permanent-family-physician-simply-wellness-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-simply-wellness-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Simply Wellness Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8964,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0674904",
            "job_listing-clinic_lattitude": 49.2460432,
            "job_listing-job_location": "49.2460432%-123.0674904",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9314"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9314"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9314"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9314"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9314"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9314"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9314"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9312,
        "date": "2023-02-23T20:28:55",
        "date_gmt": "2023-02-23T20:28:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9312"
        },
        "modified": "2023-03-03T22:30:03",
        "modified_gmt": "2023-03-03T22:30:03",
        "slug": "locum-family-physician-point-grey-gp-and-naturopathic-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-point-grey-gp-and-naturopathic-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Point Grey GP and Naturopathic Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9311,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9312"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9311"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9312"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9312"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9312"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9312"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9312"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9312"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9310,
        "date": "2023-02-23T20:27:42",
        "date_gmt": "2023-02-23T20:27:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9310"
        },
        "modified": "2023-03-03T22:30:03",
        "modified_gmt": "2023-03-03T22:30:03",
        "slug": "permanent-family-physician-point-grey-gp-and-naturopathic-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-point-grey-gp-and-naturopathic-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Point Grey GP and Naturopathic Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9311,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9310"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9311"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9310"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9310"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9310"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9310"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9310"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9310"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9308,
        "date": "2023-02-23T20:21:16",
        "date_gmt": "2023-02-23T20:21:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9308"
        },
        "modified": "2023-09-11T21:25:48",
        "modified_gmt": "2023-09-11T21:25:48",
        "slug": "permanent-family-physician-pacific-medical-clinic-kingsway",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-pacific-medical-clinic-kingsway/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Pacific Medical Clinic (Kingsway)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8945,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0647964",
            "job_listing-clinic_lattitude": 49.2446808,
            "job_listing-job_location": "49.2446808%-123.0647964",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9308"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8945"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9308"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9308"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9308"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9308"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9308"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9308"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9307,
        "date": "2023-02-23T20:19:03",
        "date_gmt": "2023-02-23T20:19:03",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9307"
        },
        "modified": "2023-09-11T18:37:19",
        "modified_gmt": "2023-09-11T18:37:19",
        "slug": "locum-family-physician-pacific-medical-clinic-grandview",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-pacific-medical-clinic-grandview/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Pacific Medical Clinic (Grandview)"
        },
        "excerpt": {
            "rendered": "<p>Multiple dates available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8944,
            "set_specific_time": true,
            "job_listing-start_date": "20231113",
            "job_listing-end_date": "20240105",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for forms and OB on-call services",
            "job_listing-description": "",
            "job_listing-job_specifics": "Dates Available:\r\nNovember 13th-17th, 2023\r\nDecember 18th, 2023-January 5th, 2024",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0367346",
            "job_listing-clinic_lattitude": 49.2589696,
            "job_listing-job_location": "49.2589696%-123.0367346",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9307"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8944"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9307"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9307"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9307"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9307"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9307"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9307"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9306,
        "date": "2023-02-23T20:16:32",
        "date_gmt": "2023-02-23T20:16:32",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9306"
        },
        "modified": "2023-03-03T22:30:03",
        "modified_gmt": "2023-03-03T22:30:03",
        "slug": "permanent-family-physician-pacific-medical-clinic-grandview",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-pacific-medical-clinic-grandview/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Pacific Medical Clinic (Grandview)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8944,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for forms and OB on-call services",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9306"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8944"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9306"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9306"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9306"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9306"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9306"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9306"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9304,
        "date": "2023-02-23T20:14:21",
        "date_gmt": "2023-02-23T20:14:21",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9304"
        },
        "modified": "2023-09-11T18:30:43",
        "modified_gmt": "2023-09-11T18:30:43",
        "slug": "permanent-family-physician-pacific-medical-clinic-fraser",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-pacific-medical-clinic-fraser/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Pacific Medical Clinic (Fraser)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9305,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed physicians",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0902688",
            "job_listing-clinic_lattitude": 49.2285535,
            "job_listing-job_location": "49.2285535%-123.0902688",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9304"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9305"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9304"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9304"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9304"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9304"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9304"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9304"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9303,
        "date": "2023-02-23T20:10:57",
        "date_gmt": "2023-02-23T20:10:57",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9303"
        },
        "modified": "2023-03-03T22:30:03",
        "modified_gmt": "2023-03-03T22:30:03",
        "slug": "permanent-family-physician-northeast-urgent-and-primary-care-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-northeast-urgent-and-primary-care-centre/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Northeast Urgent and Primary Care Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            188
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8939,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Sessional",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9303"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8939"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9303"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9303"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9303"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9303"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9303"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9303"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9301,
        "date": "2023-02-23T19:38:42",
        "date_gmt": "2023-02-23T19:38:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9301"
        },
        "modified": "2023-03-03T22:30:45",
        "modified_gmt": "2023-03-03T22:30:45",
        "slug": "locum-family-physician-laurel-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-laurel-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Laurel Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8889,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": "20230223",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9301"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8889"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9301"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9301"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9301"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9301"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9301"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9301"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9296,
        "date": "2023-02-23T19:27:41",
        "date_gmt": "2023-02-23T19:27:41",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9296"
        },
        "modified": "2023-07-25T17:39:39",
        "modified_gmt": "2023-07-25T17:39:39",
        "slug": "locum-family-physician-eighth-avenue-family-maternity-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-eighth-avenue-family-maternity-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Eighth Avenue Family &#038; Maternity Clinic"
        },
        "excerpt": {
            "rendered": "<p>Multiple dates available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8742,
            "set_specific_time": true,
            "job_listing-start_date": "20230901",
            "job_listing-end_date": "20240201",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "65/35",
            "job_listing-description": "",
            "job_listing-job_specifics": "Starting September 1, 2023: 3 half days per week, maternity care and call group optional, 70/30 billing split\r\nMaternity Locum: February 1, 2023-February 1, 2024. 4 half days per week, 65/35 split",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1234119",
            "job_listing-clinic_lattitude": 49.2640253,
            "job_listing-job_location": "49.2640253%-123.1234119",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9296"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8742"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9296"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9296"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9296"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9296"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9296"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9296"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9292,
        "date": "2023-02-23T19:27:18",
        "date_gmt": "2023-02-23T19:27:18",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9292"
        },
        "modified": "2023-04-25T22:35:30",
        "modified_gmt": "2023-04-25T22:35:30",
        "slug": "permanent-family-physician-keefer-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-keefer-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Keefer Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8878,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $1000 daily minimum (8 hour shift)",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1013456",
            "job_listing-clinic_lattitude": 49.2793542,
            "job_listing-job_location": "49.2793542%-123.1013456",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9292"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8878"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9292"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9292"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9292"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9292"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9292"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9292"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9295,
        "date": "2023-02-23T19:24:34",
        "date_gmt": "2023-02-23T19:24:34",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9295"
        },
        "modified": "2023-04-03T18:29:33",
        "modified_gmt": "2023-04-03T18:29:33",
        "slug": "permanent-family-physician-eighth-avenue-family-maternity-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-eighth-avenue-family-maternity-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Eighth Avenue Family &#038; Maternity Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8742,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "75/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1234119",
            "job_listing-clinic_lattitude": 49.2640253,
            "job_listing-job_location": "49.2640253%-123.1234119",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9295"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8742"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9295"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9295"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9295"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9295"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9295"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9295"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9291,
        "date": "2023-02-23T19:12:59",
        "date_gmt": "2023-02-23T19:12:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9291"
        },
        "modified": "2023-04-25T22:35:41",
        "modified_gmt": "2023-04-25T22:35:41",
        "slug": "permanent-family-physician-choice-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-choice-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Choice Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8774,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.115106",
            "job_listing-clinic_lattitude": 49.2863236,
            "job_listing-job_location": "49.2863236%-123.115106",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9291"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8774"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9291"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9291"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9291"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9291"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9291"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9291"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9289,
        "date": "2023-02-23T19:05:09",
        "date_gmt": "2023-02-23T19:05:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9289"
        },
        "modified": "2023-04-25T22:35:51",
        "modified_gmt": "2023-04-25T22:35:51",
        "slug": "locum-family-physician-choice-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-choice-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Choice Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8774,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "1–3-month locum with the opportunity to extend",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.115106",
            "job_listing-clinic_lattitude": 49.2863236,
            "job_listing-job_location": "49.2863236%-123.115106",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9289"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8774"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9289"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9289"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9289"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9289"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9289"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9289"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9286,
        "date": "2023-02-23T18:54:47",
        "date_gmt": "2023-02-23T18:54:47",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9286"
        },
        "modified": "2023-04-25T22:36:02",
        "modified_gmt": "2023-04-25T22:36:02",
        "slug": "permanent-family-physician-kariba-health",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-kariba-health/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Kariba Health"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8871,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "4-5 days per week, open to provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1533438",
            "job_listing-clinic_lattitude": 49.2622939,
            "job_listing-job_location": "49.2622939%-123.1533438",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9286"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8871"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9286"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9286"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9286"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9286"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9286"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9286"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9284,
        "date": "2023-02-23T18:49:56",
        "date_gmt": "2023-02-23T18:49:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9284"
        },
        "modified": "2023-06-30T20:39:58",
        "modified_gmt": "2023-06-30T20:39:58",
        "slug": "locum-family-physician-highroads-medical-clinic-kerrisdale",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-highroads-medical-clinic-kerrisdale/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Highroads Medical Clinic (Kerrisdale)"
        },
        "excerpt": {
            "rendered": "<p>Multiple Opportunities Available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8859,
            "set_specific_time": true,
            "job_listing-start_date": "20230701",
            "job_listing-end_date": "20230930",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Urgent Medical Leave",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1547082",
            "job_listing-clinic_lattitude": 49.2322668,
            "job_listing-job_location": "49.2322668%-123.1547082",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9284"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8859"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9284"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9284"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9284"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9284"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9284"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9284"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9283,
        "date": "2023-02-23T18:49:55",
        "date_gmt": "2023-02-23T18:49:55",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9283"
        },
        "modified": "2023-06-09T17:03:08",
        "modified_gmt": "2023-06-09T17:03:08",
        "slug": "locum-family-physician-downtown-community-health-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-downtown-community-health-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Downtown Community Health Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            189
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8832,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Alternate Payment Model",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9283"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8832"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9283"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9283"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9283"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9283"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9283"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9283"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9281,
        "date": "2023-02-23T18:47:04",
        "date_gmt": "2023-02-23T18:47:04",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9281"
        },
        "modified": "2023-03-03T22:30:45",
        "modified_gmt": "2023-03-03T22:30:45",
        "slug": "permanent-family-physician-doc-side-medical",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-doc-side-medical/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Doc-Side Medical"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8822,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9281"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8822"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9281"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9281"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9281"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9281"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9281"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9281"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9280,
        "date": "2023-02-23T18:45:09",
        "date_gmt": "2023-02-23T18:45:09",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9280"
        },
        "modified": "2023-03-03T22:30:45",
        "modified_gmt": "2023-03-03T22:30:45",
        "slug": "permanent-family-physician-denman-medical-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-denman-medical-centre/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Denman Medical Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8820,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9280"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8820"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9280"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9280"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9280"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9280"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9280"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9280"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9272,
        "date": "2023-02-23T18:43:43",
        "date_gmt": "2023-02-23T18:43:43",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9272"
        },
        "modified": "2023-03-03T22:30:45",
        "modified_gmt": "2023-03-03T22:30:45",
        "slug": "locum-family-physician-denman-medical-centre",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-denman-medical-centre/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Denman Medical Centre"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8820,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9272"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8820"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9272"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9272"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9272"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9272"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9272"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9272"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9270,
        "date": "2023-02-23T18:40:20",
        "date_gmt": "2023-02-23T18:40:20",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9270"
        },
        "modified": "2023-03-27T21:22:31",
        "modified_gmt": "2023-03-27T21:22:31",
        "slug": "locum-family-physician-cross-roads-walk-in-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-cross-roads-walk-in-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Cross Roads Walk in Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8809,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "65/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1153912",
            "job_listing-clinic_lattitude": 49.2634635,
            "job_listing-job_location": "49.2634635%-123.1153912",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9270"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8809"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9270"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9270"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9270"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9270"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9270"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9270"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9269,
        "date": "2023-02-23T18:38:31",
        "date_gmt": "2023-02-23T18:38:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9269"
        },
        "modified": "2023-03-03T22:30:45",
        "modified_gmt": "2023-03-03T22:30:45",
        "slug": "permanent-family-physician-cross-roads-walk-in-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-cross-roads-walk-in-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Cross Roads Walk in Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            139
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8809,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "65/25",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9269"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8809"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9269"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9269"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9269"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9269"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9269"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9269"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9267,
        "date": "2023-02-23T18:36:02",
        "date_gmt": "2023-02-23T18:36:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9267"
        },
        "modified": "2023-03-03T22:31:15",
        "modified_gmt": "2023-03-03T22:31:15",
        "slug": "permanent-family-physician-coal-harbour-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-coal-harbour-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Coal Harbour Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8798,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9267"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8798"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9267"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9267"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9267"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9267"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9267"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9267"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9263,
        "date": "2023-02-23T18:25:56",
        "date_gmt": "2023-02-23T18:25:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9263"
        },
        "modified": "2023-03-27T21:22:56",
        "modified_gmt": "2023-03-27T21:22:56",
        "slug": "permanent-family-physician-city-med",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-city-med/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; CityMed"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8783,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "80/20",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1005344",
            "job_listing-clinic_lattitude": 49.26613,
            "job_listing-job_location": "49.26613%-123.1005344",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9263"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8783"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9263"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9263"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9263"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9263"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9263"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9263"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9264,
        "date": "2023-02-23T18:09:02",
        "date_gmt": "2023-02-23T18:09:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9264"
        },
        "modified": "2023-04-25T22:37:46",
        "modified_gmt": "2023-04-25T22:37:46",
        "slug": "permanent-family-physician-caritas-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-caritas-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Caritas Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8762,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $750 daily minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "Full-time and part-time opportunities available",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0657014",
            "job_listing-clinic_lattitude": 49.2340685,
            "job_listing-job_location": "49.2340685%-123.0657014",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9264"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8762"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9264"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9264"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9264"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9264"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9264"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9264"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9261,
        "date": "2023-02-23T18:05:04",
        "date_gmt": "2023-02-23T18:05:04",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9261"
        },
        "modified": "2023-04-25T22:37:54",
        "modified_gmt": "2023-04-25T22:37:54",
        "slug": "flexible-locum-caritas-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/flexible-locum-caritas-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Caritas Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8762,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, $750 daily minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "Full-time and part-time opportunities available",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0657014",
            "job_listing-clinic_lattitude": 49.2340685,
            "job_listing-job_location": "49.2340685%-123.0657014",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9261"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8762"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9261"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9261"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9261"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9261"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9261"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9261"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9257,
        "date": "2023-02-22T20:47:48",
        "date_gmt": "2023-02-22T20:47:48",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9257"
        },
        "modified": "2023-04-25T22:38:10",
        "modified_gmt": "2023-04-25T22:38:10",
        "slug": "permanent-family-physician-genetica-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-genetica-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Genetica Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8839,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "72/28, Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "Permanent family physician needed - Full and part time opportunities available with the ability to cover the walk-in and/or establish a regular patient panel. The clinic is able to accommodate specialist and special interest/subspecialty practices and is open to provisionally licensed candidates.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1280715",
            "job_listing-clinic_lattitude": 49.2793325,
            "job_listing-job_location": "49.2793325%-123.1280715",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9257"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8839"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9257"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9257"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9257"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9257"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9257"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9257"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9256,
        "date": "2023-02-22T20:43:08",
        "date_gmt": "2023-02-22T20:43:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9256"
        },
        "modified": "2023-04-25T22:38:15",
        "modified_gmt": "2023-04-25T22:38:15",
        "slug": "locum-family-physician-genetica-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-genetica-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Genetica Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8839,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "72/28, Negotiable",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1280715",
            "job_listing-clinic_lattitude": 49.2793325,
            "job_listing-job_location": "49.2793325%-123.1280715",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9256"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8839"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9256"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9256"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9256"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9256"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9256"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9256"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9255,
        "date": "2023-02-22T20:41:08",
        "date_gmt": "2023-02-22T20:41:08",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9255"
        },
        "modified": "2023-04-25T22:38:21",
        "modified_gmt": "2023-04-25T22:38:21",
        "slug": "permanent-family-physician-forward-care-medical-clinic-east-vancouver",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-forward-care-medical-clinic-east-vancouver/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Forward Care Medical Clinic (East Vancouver)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8836,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": "20230222",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for medical/legal reports",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0504595",
            "job_listing-clinic_lattitude": 49.2326142,
            "job_listing-job_location": "49.2326142%-123.0504595",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9255"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8836"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9255"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9255"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9255"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9255"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9255"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9255"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9254,
        "date": "2023-02-22T20:39:06",
        "date_gmt": "2023-02-22T20:39:06",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9254"
        },
        "modified": "2023-04-25T22:38:35",
        "modified_gmt": "2023-04-25T22:38:35",
        "slug": "locum-family-physician-forward-care-medical-clinic-east-vancouver",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-forward-care-medical-clinic-east-vancouver/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Forward Care Medical Clinic (East Vancouver)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8836,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 100% for medical/legal reports",
            "job_listing-description": "",
            "job_listing-job_specifics": "Saturdays, long term and short-term opportunities available",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0504595",
            "job_listing-clinic_lattitude": 49.2326142,
            "job_listing-job_location": "49.2326142%-123.0504595",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9254"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8836"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9254"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9254"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9254"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9254"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9254"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9254"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9253,
        "date": "2023-02-22T20:20:52",
        "date_gmt": "2023-02-22T20:20:52",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9253"
        },
        "modified": "2023-04-25T22:38:46",
        "modified_gmt": "2023-04-25T22:38:46",
        "slug": "permanent-family-physician-ting-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-ting-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Ting Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8992,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Wednesdays full day plus 2-3 hours per week on Monday, Tuesday, Thursday or Friday afternoons",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1250251",
            "job_listing-clinic_lattitude": 49.2637081,
            "job_listing-job_location": "49.2637081%-123.1250251",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9253"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8992"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9253"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9253"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9253"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9253"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9253"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9253"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9248,
        "date": "2023-02-22T20:02:44",
        "date_gmt": "2023-02-22T20:02:44",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9248"
        },
        "modified": "2023-05-02T23:26:18",
        "modified_gmt": "2023-05-02T23:26:18",
        "slug": "permanent-family-physician-alberni-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-alberni-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Alberni Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9244,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1281668",
            "job_listing-clinic_lattitude": 49.2879721,
            "job_listing-job_location": "49.2879721%-123.1281668",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9248"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9244"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9248"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9248"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9248"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9248"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9248"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9248"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9246,
        "date": "2023-02-22T20:00:41",
        "date_gmt": "2023-02-22T20:00:41",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9246"
        },
        "modified": "2023-04-25T22:39:05",
        "modified_gmt": "2023-04-25T22:39:05",
        "slug": "locum-family-physician-alberni-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-alberni-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Alberni Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9244,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1281668",
            "job_listing-clinic_lattitude": 49.2879721,
            "job_listing-job_location": "49.2879721%-123.1281668",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9246"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9244"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9246"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9246"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9246"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9246"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9246"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9246"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9247,
        "date": "2023-02-22T20:00:07",
        "date_gmt": "2023-02-22T20:00:07",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9247"
        },
        "modified": "2023-04-25T22:39:13",
        "modified_gmt": "2023-04-25T22:39:13",
        "slug": "permanent-family-physician-care-point-medical-clinic-joyce-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-care-point-medical-clinic-joyce-st/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Care Point Medical Clinic (Joyce)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8758,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 75/25 weekend shifts",
            "job_listing-description": "",
            "job_listing-job_specifics": "Open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0319535",
            "job_listing-clinic_lattitude": 49.2378195,
            "job_listing-job_location": "49.2378195%-123.0319535",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9247"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9247"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9247"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9247"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9247"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9247"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9247"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9245,
        "date": "2023-02-22T19:57:49",
        "date_gmt": "2023-02-22T19:57:49",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9245"
        },
        "modified": "2023-03-03T22:28:12",
        "modified_gmt": "2023-03-03T22:28:12",
        "slug": "part-time-flexible-locum-care-point-medical-clinic-joyce-st",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/part-time-flexible-locum-care-point-medical-clinic-joyce-st/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Care Point Medical Clinic (Joyce)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8758,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 75/25 weekend shifts",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "",
            "job_listing-clinic_lattitude": "",
            "job_listing-job_location": "%",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9245"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9245"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9245"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9245"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9245"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9245"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9245"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9242,
        "date": "2023-02-22T19:52:51",
        "date_gmt": "2023-02-22T19:52:51",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9242"
        },
        "modified": "2023-05-02T23:26:44",
        "modified_gmt": "2023-05-02T23:26:44",
        "slug": "locum-family-physician-acadia-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-family-physician-acadia-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Acadia Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 9240,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2371773",
            "job_listing-clinic_lattitude": 49.2653879,
            "job_listing-job_location": "49.2653879%-123.2371773",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9242"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9240"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9242"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9242"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9242"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9242"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9242"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9242"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9241,
        "date": "2023-02-22T19:49:36",
        "date_gmt": "2023-02-22T19:49:36",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9241"
        },
        "modified": "2023-05-02T19:27:13",
        "modified_gmt": "2023-05-02T19:27:13",
        "slug": "full-time-permanent-family-physician-care-point-medical-clinic-commercial-dr",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/full-time-permanent-family-physician-care-point-medical-clinic-commercial-dr/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Care Point Medical Clinic (Commercial)"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8754,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, 75/25 weekend shifts (APP contracts available)",
            "job_listing-description": "",
            "job_listing-job_specifics": "Monday-Friday 2pm-6pm/7pm, Saturdays 9am-4pm",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.069817",
            "job_listing-clinic_lattitude": 49.2701651,
            "job_listing-job_location": "49.2701651%-123.069817",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9241"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8754"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9241"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9241"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9241"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9241"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9241"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9241"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9232,
        "date": "2023-02-22T19:49:19",
        "date_gmt": "2023-02-22T19:49:19",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9232"
        },
        "modified": "2023-04-25T22:39:34",
        "modified_gmt": "2023-04-25T22:39:34",
        "slug": "permanent-family-physician-acadia-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-acadia-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Acadia Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 9240,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.2371773",
            "job_listing-clinic_lattitude": 49.2653879,
            "job_listing-job_location": "49.2653879%-123.2371773",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9232"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/9240"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9232"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9232"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9232"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9232"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9232"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9232"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9239,
        "date": "2023-02-22T19:39:47",
        "date_gmt": "2023-02-22T19:39:47",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9239"
        },
        "modified": "2023-04-25T22:39:42",
        "modified_gmt": "2023-04-25T22:39:42",
        "slug": "long-term-locum-blue-water-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/long-term-locum-blue-water-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Blue Water Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8749,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, negotiable hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "Long Term Locum",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0380326",
            "job_listing-clinic_lattitude": 49.2352974,
            "job_listing-job_location": "49.2352974%-123.0380326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9239"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8749"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9239"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9239"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9239"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9239"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9239"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9239"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9235,
        "date": "2023-02-22T19:38:56",
        "date_gmt": "2023-02-22T19:38:56",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9235"
        },
        "modified": "2023-04-25T22:39:53",
        "modified_gmt": "2023-04-25T22:39:53",
        "slug": "permanent-family-physician-blue-water-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-blue-water-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Blue Water Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            145
        ],
        "joblisting_ft_pt": [],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8749,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30, negotiable hourly minimum",
            "job_listing-description": "",
            "job_listing-job_specifics": "This opportunity is open to both fully and provisionally licensed candidates",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0380326",
            "job_listing-clinic_lattitude": 49.2352974,
            "job_listing-job_location": "49.2352974%-123.0380326",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9235"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8749"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9235"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9235"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9235"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9235"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9235"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9235"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9234,
        "date": "2023-02-22T19:32:17",
        "date_gmt": "2023-02-22T19:32:17",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9234"
        },
        "modified": "2023-03-27T21:24:42",
        "modified_gmt": "2023-03-27T21:24:42",
        "slug": "flexible-locum-city-med-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/flexible-locum-city-med-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; CityMed"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8783,
            "set_specific_time": true,
            "job_listing-start_date": "20230222",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "80/20",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1005344",
            "job_listing-clinic_lattitude": 49.26613,
            "job_listing-job_location": "49.26613%-123.1005344",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9234"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8783"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9234"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9234"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9234"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9234"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9234"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9234"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9231,
        "date": "2023-02-22T19:21:48",
        "date_gmt": "2023-02-22T19:21:48",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9231"
        },
        "modified": "2023-07-25T17:36:13",
        "modified_gmt": "2023-07-25T17:36:13",
        "slug": "part-time-locum-broadway-plaza-family-practice",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/part-time-locum-broadway-plaza-family-practice/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Broadway Plaza Family Practice"
        },
        "excerpt": {
            "rendered": "<p>Multiple dates available</p>\n",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            141
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8751,
            "set_specific_time": true,
            "job_listing-start_date": "20230908",
            "job_listing-end_date": "20230922",
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "Long term locum - Fridays/September 8-22, 2023",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1181345",
            "job_listing-clinic_lattitude": 49.2636573,
            "job_listing-job_location": "49.2636573%-123.1181345",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9231"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8751"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9231"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9231"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9231"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9231"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9231"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9231"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9230,
        "date": "2023-02-22T19:14:59",
        "date_gmt": "2023-02-22T19:14:59",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9230"
        },
        "modified": "2023-05-02T23:27:59",
        "modified_gmt": "2023-05-02T23:27:59",
        "slug": "flexible-locum-aquarius-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/flexible-locum-aquarius-medical-clinic/",
        "title": {
            "rendered": "Locum Family Physician &#8211; Aquarius Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [
            207,
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8743,
            "set_specific_time": true,
            "job_listing-start_date": "20230223",
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1205414",
            "job_listing-clinic_lattitude": 49.2738533,
            "job_listing-job_location": "49.2738533%-123.1205414",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9230"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8743"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9230"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9230"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9230"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9230"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9230"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9230"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 9227,
        "date": "2023-02-22T18:50:24",
        "date_gmt": "2023-02-22T18:50:24",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=9227"
        },
        "modified": "2023-05-02T23:27:53",
        "modified_gmt": "2023-05-02T23:27:53",
        "slug": "permanent-family-physician-aquarius-medical-clinic",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/permanent-family-physician-aquarius-medical-clinic/",
        "title": {
            "rendered": "Permanent Family Physician &#8211; Aquarius Medical Clinic"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [],
        "joblisting_clinic_type": [
            140
        ],
        "joblisting_community": [
            147
        ],
        "joblisting_ft_pt": [],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8743,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "70/30",
            "job_listing-description": "",
            "job_listing-job_specifics": "This opportunity is open to both fully and provisionally licensed candidates.",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1205414",
            "job_listing-clinic_lattitude": 49.2738533,
            "job_listing-job_location": "49.2738533%-123.1205414",
            "email_recipient": "recruitment@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9227"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8743"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9227"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9227"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9227"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9227"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9227"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9227"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8377,
        "date": "2022-12-16T01:06:20",
        "date_gmt": "2022-12-16T01:06:20",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=8377"
        },
        "modified": "2023-02-22T08:29:33",
        "modified_gmt": "2023-02-22T08:29:33",
        "slug": "locum-little-mountain-place",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/locum-little-mountain-place/",
        "title": {
            "rendered": "Locum Part-Time FP for Long Term Care Panel at Little Mountain Place"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            143
        ],
        "joblisting_ft_pt": [],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 8376,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "If you have experience in care of the elderly or an interest in this work, augment your practice with a long term care panel! Long Term Care (LTC) locum placements provide flexibility, allow you to diversify your work and to get a feel for the LTC landscape in Vancouver.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You qualify for the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Depending on the duration of the locum work, participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplementing other family practice work with a LTC locum adds variety to your workday</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There is a strong LTC community of practice and a variety of care homes throughout the city providing interesting locum and permanent opportunities</li>\r\n \t<li>You can join the LTCI Locum Roster and flexibly turn on/off your availability to take locum opportunities</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice LTCI enables physicians who work in long term care and commit to the LTCI Locum Roster Agreement to receive additional funding if they meet five identified best practice expectations in their care home work. The best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; and completed documentation in charts.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI Locum Roster and take on a locum placement also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed prorated for the length of the locum agreement</li>\r\n \t<li>If participating in the after-hours care program, payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0997913",
            "job_listing-clinic_lattitude": 49.2375107,
            "job_listing-job_location": "49.2375107%-123.0997913",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/8377"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8376"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8377"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=8377"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=8377"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=8377"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=8377"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=8377"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 8375,
        "date": "2022-12-16T00:53:42",
        "date_gmt": "2022-12-16T00:53:42",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=8375"
        },
        "modified": "2023-02-22T08:30:01",
        "modified_gmt": "2023-02-22T08:30:01",
        "slug": "louis-brier",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/louis-brier/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Louis Brier Home and Hospital &#038; Weinberg Residence"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 8374,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1292208",
            "job_listing-clinic_lattitude": 49.2345285,
            "job_listing-job_location": "49.2345285%-123.1292208",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/8375"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/8374"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8375"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=8375"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=8375"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=8375"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=8375"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=8375"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7926,
        "date": "2022-11-18T06:38:31",
        "date_gmt": "2022-11-18T06:38:31",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=7926"
        },
        "modified": "2023-02-22T08:30:33",
        "modified_gmt": "2023-02-22T08:30:33",
        "slug": "long-term-care-locum-roster",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/long-term-care-locum-roster/",
        "title": {
            "rendered": "Locum Part-Time FP for Long Term Care Locum Roster"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            137
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            147,
            146,
            145,
            144,
            143,
            142
        ],
        "joblisting_ft_pt": [],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Locum"
            ],
            "job_listing-clinic": 7925,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "If you have experience in care of the elderly or an interest in this work and would like to be placed on our Long Term Care Initiative (LTCI) Locum Roster, please contact us. Long Term Care (LTC) locum opportunities will be filled from this roster of physicians. Locum placements provide flexibility, allow you to diversify your work and to get a feel for the LTC landscape in Vancouver.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You qualify for the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Depending on the duration of the locum work, participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplementing other family practice work with a LTC locum adds variety to your workday</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There is a strong LTC community of practice and a variety of care homes throughout the city providing interesting locum opportunities</li>\r\n \t<li>Once you are accepted onto the locum roster you can flexibly turn on/off your availability to take locum opportunities</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice LTCI enables physicians who work in long term care and commit to the LTCI Locum Roster Agreement to receive additional funding if they meet five identified best practice expectations in their care home work. The best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; and completed documentation in charts.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI Locum Roster and take on a locum placement also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed prorated for the length of the locum agreement</li>\r\n \t<li>If participating in the after-hours care program, payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1213494",
            "job_listing-clinic_lattitude": 49.2635975,
            "job_listing-job_location": "49.2635975%-123.1213494",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7926"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/7925"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7926"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7926"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7926"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7926"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7926"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7926"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7924,
        "date": "2022-11-18T06:18:16",
        "date_gmt": "2022-11-18T06:18:16",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=7924"
        },
        "modified": "2023-08-14T23:50:48",
        "modified_gmt": "2023-08-14T23:50:48",
        "slug": "villa-cathay-care-home",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/villa-cathay-care-home/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Villa Cathay Care Home"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Physician",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 7923,
            "set_specific_time": false,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.0836056",
            "job_listing-clinic_lattitude": 49.2771776,
            "job_listing-job_location": "49.2771776%-123.0836056",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7924"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/7923"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7924"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7924"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7924"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7924"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7924"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7924"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7922,
        "date": "2022-11-18T06:14:27",
        "date_gmt": "2022-11-18T06:14:27",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=7922"
        },
        "modified": "2023-02-22T08:31:36",
        "modified_gmt": "2023-02-22T08:31:36",
        "slug": "sunrise-senior-living-of-vancouver",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/sunrise-senior-living-of-vancouver/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Sunrise Senior Living of Vancouver"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            142
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 7921,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1277386",
            "job_listing-clinic_lattitude": 49.2196624,
            "job_listing-job_location": "49.2196624%-123.1277386",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7922"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/7921"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7922"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7922"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7922"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7922"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7922"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7922"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7920,
        "date": "2022-11-18T06:07:02",
        "date_gmt": "2022-11-18T06:07:02",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=7920"
        },
        "modified": "2023-02-22T08:32:10",
        "modified_gmt": "2023-02-22T08:32:10",
        "slug": "crofton-manor",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/crofton-manor/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Crofton Manor"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            144
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 6387,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.1677477",
            "job_listing-clinic_lattitude": 49.235294,
            "job_listing-job_location": "49.235294%-123.1677477",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7920"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/6387"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7920"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7920"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7920"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7920"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7920"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7920"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 7919,
        "date": "2022-11-18T06:00:41",
        "date_gmt": "2022-11-18T06:00:41",
        "guid": {
            "rendered": "https://van-division.yarko.dev/?post_type=job_listing&#038;p=7919"
        },
        "modified": "2023-02-22T08:32:43",
        "modified_gmt": "2023-02-22T08:32:43",
        "slug": "britannia-lodge",
        "status": "publish",
        "type": "job_listing",
        "link": "https://van-division.yarko.dev/job_listing/britannia-lodge/",
        "title": {
            "rendered": "Permanent Part-Time FP for Long Term Care Panel at Britannia Lodge"
        },
        "excerpt": {
            "rendered": "",
            "protected": false
        },
        "template": "",
        "joblisting_practice_type": [
            131
        ],
        "joblisting_job_type": [
            136
        ],
        "joblisting_clinic_type": [
            138
        ],
        "joblisting_community": [
            146
        ],
        "joblisting_ft_pt": [
            206
        ],
        "acf": {
            "job_listing-practice_type": "Family Practice",
            "job_listing-job_type": [
                "Permanent"
            ],
            "job_listing-clinic": 6449,
            "set_specific_time": true,
            "job_listing-start_date": null,
            "job_listing-end_date": null,
            "non_specific_date_message": "Negotiable",
            "job_listing-remuneration": "Fee-for-Service with additional incentive payments (see further information below)",
            "job_listing-description": "Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>Specialized mental health population; expand on your mental health skillset and apply your expertise to a LTC setting</li>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>",
            "job_listing-job_specifics": "The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>",
            "job_listing-information": "",
            "job_listing-other_information": "",
            "job_listing-clinic_longitude": "-123.065204",
            "job_listing-clinic_lattitude": 49.2750673,
            "job_listing-job_location": "49.2750673%-123.065204",
            "email_recipient": "ltc@van-division.yarko.dev",
            "resume-invite": ""
        },
        "aioseo_notices": [],
        "_links": {
            "self": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7919"
                }
            ],
            "collection": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/job_listing"
                }
            ],
            "about": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"
                }
            ],
            "acf:post": [
                {
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/clinic/6449"
                }
            ],
            "wp:attachment": [
                {
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7919"
                }
            ],
            "wp:term": [
                {
                    "taxonomy": "joblisting_practice_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7919"
                },
                {
                    "taxonomy": "joblisting_job_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7919"
                },
                {
                    "taxonomy": "joblisting_clinic_type",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7919"
                },
                {
                    "taxonomy": "joblisting_community",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7919"
                },
                {
                    "taxonomy": "joblisting_ft_pt",
                    "embeddable": true,
                    "href": "https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7919"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    }
]

export default database;


// WEBPACK FOOTER //
// ./src/database.js